var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _g, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _g2, _g3, _g4, _g5, _g6, _g7, _path413, _path414, _path415, _path416, _g8, _g9, _g10, _g11, _g12, _g13, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _g14, _g15, _g16, _g17, _g18, _g19, _path436, _path437, _path438, _path439, _g20, _g21, _g22, _g23, _g24, _g25, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _g26, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _g27, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _g28, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmartCity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 228,
    viewBox: "0 0 306 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 305.33,
    height: 227.508,
    transform: "translate(0.320312)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M188.77 12.421H181.238V159.399H188.77V12.421Z",
    fill: "#B3CCE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.594 43.606H111.062V159.405H118.594V43.606Z",
    fill: "#B3CCE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1309 56.9772H77.5996V159.399H85.1309V56.9772Z",
    fill: "#B3CCE5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M226.775 56.9772H219.244V159.399H226.775V56.9772Z",
    fill: "#B3CCE5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M298.025 211.946H273.994V212.1H298.025V211.946Z",
    fill: "#DCEAF8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M211.914 213.624H205.609V213.779H211.914V213.624Z",
    fill: "#DCEAF8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M273.269 206.22H259.346V206.374H273.269V206.22Z",
    fill: "#DCEAF8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9951 207.256H9.6582V207.411H40.9951V207.256Z",
    fill: "#DCEAF8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0518 207.256H47.459V207.411H52.0518V207.256Z",
    fill: "#DCEAF8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M134.955 209.86H66.9844V210.015H134.955V209.86Z",
    fill: "#DCEAF8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M110.555 54.2005C110.555 46.8578 105.607 44.4266 101.791 43.9824C95.5435 43.2604 91.0741 47.3082 91.0741 47.3082C91.0741 47.3082 87.6784 37.5652 75.402 37.5652C63.1255 37.5652 59.3453 48.2091 59.3453 48.2091C55.9601 46.1853 51.7741 45.3762 47.6928 45.9569C42.8751 46.6418 40.0019 49.6591 36.8965 54.2005H110.555Z",
    fill: "#C5E0FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M260.905 19.2454C260.905 16.2651 258.896 15.2778 257.343 15.0989C256.546 15.0387 255.743 15.1279 254.991 15.3603C254.238 15.5927 253.555 15.9627 252.989 16.444C252.989 16.444 251.611 12.4888 246.619 12.4888C241.627 12.4888 240.089 16.8081 240.089 16.8081C238.716 15.9844 237.015 15.6561 235.358 15.8949C233.399 16.1725 232.231 17.4004 230.969 19.2392L260.905 19.2454Z",
    fill: "#C5E0FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M249.862 32.3945C249.862 27.7852 246.756 26.2241 244.355 25.9773C240.43 25.5269 237.629 28.0691 237.629 28.0691C237.629 28.0691 235.496 21.9481 227.783 21.9481C220.07 21.9481 217.698 28.6306 217.698 28.6306C215.573 27.3612 212.946 26.8536 210.384 27.2176C207.359 27.6495 205.552 29.55 203.607 32.3945H249.862Z",
    fill: "#C5E0FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7266 24.6815C23.7266 24.6815 25.1777 21.5963 28.8563 21.2385C29.854 21.1099 30.8739 21.2005 31.8188 21.5019C32.7637 21.8032 33.6022 22.3052 34.2544 22.96C34.2544 22.96 37.1131 18.6407 42.6782 19.2578C48.7874 19.9365 48.4319 24.6877 48.4319 24.6877L23.7266 24.6815Z",
    fill: "#C5E0FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M219.359 46.4938C219.359 46.4938 222.784 39.2868 231.266 38.5032C239.748 37.7195 243.833 42.5016 243.833 42.5016C243.833 42.5016 250.471 32.4439 263.423 33.863C277.615 35.4427 276.795 46.4753 276.795 46.4753L219.359 46.4938Z",
    fill: "#C5E0FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M154.095 50.2947C167.03 50.2947 177.516 41.3771 177.516 30.3768C177.516 19.3764 167.03 10.4588 154.095 10.4588C141.16 10.4588 130.674 19.3764 130.674 30.3768C130.674 41.3771 141.16 50.2947 154.095 50.2947Z",
    fill: "#C5E0FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M116.417 159.405H90.3984V55.0026L116.417 66.8867V159.405Z",
    fill: "#C9DDF1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M262.733 158.831L226.789 159.405L236.41 78.3452H250.776L262.733 158.831Z",
    fill: "#C9DDF1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M154.102 66.1032H140.984V159.399H154.102V66.1032Z",
    fill: "#C9DDF1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M173.735 53.9413H160.617V159.399H173.735V53.9413Z",
    fill: "#C9DDF1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7221 74.1246H53.1191V159.399H65.7221V74.1246Z",
    fill: "#C9DDF1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5176 79.0486C68.4135 79.0486 75.625 76.1175 75.625 72.5018C75.625 68.8862 68.4135 65.9551 59.5176 65.9551C50.6217 65.9551 43.4102 68.8862 43.4102 72.5018C43.4102 76.1175 50.6217 79.0486 59.5176 79.0486Z",
    fill: "#C9DDF1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M210.864 91.8707H197.746V159.399H210.864V91.8707Z",
    fill: "#C9DDF1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M205.269 94.5979C215.9 94.5979 224.518 91.095 224.518 86.7739C224.518 82.4528 215.9 78.9499 205.269 78.9499C194.638 78.9499 186.02 82.4528 186.02 86.7739C186.02 91.095 194.638 94.5979 205.269 94.5979Z",
    fill: "#C9DDF1"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M131.314 57.403H124.436V159.948H131.314V57.403Z",
    fill: "#C9DDF1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M133.553 86.9647C136.747 84.249 136.747 79.846 133.553 77.1303C130.36 74.4146 125.182 74.4146 121.989 77.1303C118.796 79.846 118.796 84.249 121.989 86.9647C125.182 89.6804 130.36 89.6804 133.553 86.9647Z",
    fill: "#C9DDF1"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M152.985 227.508C230.68 227.508 293.664 224.38 293.664 220.523C293.664 216.665 230.68 213.538 152.985 213.538C75.2907 213.538 12.3066 216.665 12.3066 220.523C12.3066 224.38 75.2907 227.508 152.985 227.508Z",
    fill: "#C5E0FF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9805 158.936V160.645C35.9805 162.626 88.2208 164.23 152.672 164.23C217.124 164.23 269.364 162.626 269.364 160.645V158.936H35.9805Z",
    fill: "#263238"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M35.9805 158.936V160.645C35.9805 162.626 88.2208 164.23 152.672 164.23C217.124 164.23 269.364 162.626 269.364 160.645V158.936H35.9805Z",
    fill: "#E0E0E0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M152.672 162.521C217.117 162.521 269.364 160.917 269.364 158.936H35.9805C35.9805 160.917 88.2281 162.521 152.672 162.521Z",
    fill: "#263238"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M152.672 162.521C217.117 162.521 269.364 160.917 269.364 158.936H35.9805C35.9805 160.917 88.2281 162.521 152.672 162.521Z",
    fill: "#E0E0E0"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M103.885 76.4694L120.783 87.0947L122.663 159.177H96.5352L103.885 76.4694Z",
    fill: "url(#paint0_linear_1604_23319)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M103.885 76.4694L120.783 87.0947L122.663 159.177H96.5352L103.885 76.4694Z",
    fill: "#E0E0E0"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M118.042 109.851H113.035V159.183H118.042V109.851Z",
    fill: "#263238"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M116.787 159.196H132.292L120.784 87.0948C117.309 96.2146 112.876 106.34 113.035 110.271L116.787 159.196Z",
    fill: "url(#paint1_linear_1604_23319)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M116.787 159.196H132.292L120.784 87.0948C117.309 96.2146 112.876 106.34 113.035 110.271L116.787 159.196Z",
    fill: "#E0E0E0"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M111.909 157.264H98.1309L98.2905 155.351H111.909V157.264Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M131.267 157.264H117.518L117.344 155.351H130.963L131.267 157.264Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M130.346 151.526H116.989L116.814 149.613H130.041L130.346 151.526Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M129.425 145.781H116.474L116.307 143.868H129.12L129.425 145.781Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M128.534 140.043H115.974L115.793 138.13H128.2L128.534 140.043Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M127.583 134.298H115.531L115.328 132.385H127.278L127.583 134.298Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M126.66 128.56H115.008L114.877 126.647H126.355L126.66 128.56Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M125.739 122.821H114.602L114.479 120.902H125.434L125.739 122.821Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M124.818 117.077H114.246L114.145 115.164H124.513L124.818 117.077Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M123.896 111.338H114.014L114.05 109.425H123.591L123.896 111.338Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M122.946 105.594H114.762L115.415 103.681H122.663L122.946 105.594Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M122.053 99.8551H116.742L117.453 97.9423H121.749L122.053 99.8551Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M121.132 94.1166H118.854L119.637 92.1976H120.827L121.132 94.1166Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M111.91 154.395H98.3711L98.5307 152.482H111.91V154.395Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M111.911 151.526H98.6113L98.771 149.613H111.911V151.526Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M111.91 148.657H98.8496L99.0092 146.738H111.91V148.657Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M111.91 145.781H99.0898L99.2495 143.868H111.91V145.781Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M111.911 142.912H99.3301L99.4897 140.999H111.911V142.912Z",
    fill: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M111.91 140.043H99.5684L99.728 138.13H111.91V140.043Z",
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M111.911 137.173H99.8086L99.9682 135.261H111.911V137.173Z",
    fill: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M111.91 134.298H100.047L100.206 132.385H111.91V134.298Z",
    fill: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M111.911 131.429H100.295L100.447 129.516H111.911V131.429Z",
    fill: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M111.91 128.56H100.533L100.693 126.647H111.91V128.56Z",
    fill: "black"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M111.911 125.69H100.773L100.933 123.778H111.911V125.69Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M111.912 122.821H101.014L101.173 120.902H111.912V122.821Z",
    fill: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M111.91 119.946H101.252L101.412 118.033H111.91V119.946Z",
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M111.911 117.077H101.492L101.652 115.164H111.911V117.077Z",
    fill: "black"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M111.91 114.207H101.73L101.89 112.295H111.91V114.207Z",
    fill: "black"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M111.911 111.338H101.971L102.13 109.425H111.911V111.338Z",
    fill: "black"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M111.91 108.469H102.209L102.369 106.55H112.367L111.91 108.469Z",
    fill: "black"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M112.6 105.594H102.449L102.609 103.681H113.137L112.6 105.594Z",
    fill: "black"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M113.428 102.724H102.689L102.849 100.812H114.052L113.428 102.724Z",
    fill: "black"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M114.384 99.8551H102.928L103.087 97.9423H115.081L114.384 99.8551Z",
    fill: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M115.444 96.9859H103.168L103.328 95.0731H116.177L115.444 96.9859Z",
    fill: "black"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M116.553 94.1166H103.406L103.566 92.1976H117.315L116.553 94.1166Z",
    fill: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M117.693 91.2412H103.646L103.806 89.3284H118.455L117.693 91.2412Z",
    fill: "black"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M118.833 88.372H103.887L104.046 86.4592H117.099L119.065 87.7612L118.833 88.372Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M115.654 85.5028H104.125L104.285 83.59H112.759L115.654 85.5028Z",
    fill: "black"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M111.314 82.6335H104.363L104.523 80.7145H108.426L111.314 82.6335Z",
    fill: "black"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9395 159.195H52.0371V116.743H77.1923C90.2741 123.901 94.983 139.179 94.9395 159.195Z",
    fill: "url(#paint2_linear_1604_23319)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M94.9395 159.195H52.0371V116.743H77.1923C90.2741 123.901 94.983 139.179 94.9395 159.195Z",
    fill: "#E0E0E0"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8061 159.195H52.0371V116.743C65.119 123.901 69.8278 139.179 69.8061 159.195Z",
    fill: "#263238"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M69.8061 159.195H52.0371V116.743C65.119 123.901 69.8278 139.179 69.8061 159.195Z",
    fill: "#E0E0E0"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4092 159.195H52.0371V127.258C61.883 132.663 65.4309 144.134 65.4092 159.195Z",
    fill: "#263238"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M93.6835 158.363H70.8066V157.295L93.6835 157.443V158.363Z",
    fill: "#E0E0E0"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M93.6908 156.283H70.8066V155.358H93.6545L93.6908 156.283Z",
    fill: "black"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M93.6258 154.204H70.8867V153.278H93.5895L93.6258 154.204Z",
    fill: "#E0E0E0"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M93.5385 152.118H70.8067L70.7559 151.193H93.5385V152.118Z",
    fill: "black"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M93.4235 150.039H70.6844L70.6191 149.113H93.3582L93.4235 150.039Z",
    fill: "#E0E0E0"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M93.2622 147.953H70.5522L70.4434 147.028H93.1752L93.2622 147.953Z",
    fill: "black"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M93.0608 145.874H70.3217L70.2129 144.948H92.9519L93.0608 145.874Z",
    fill: "#E0E0E0"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M92.7993 143.794H70.0603L69.9297 142.869H92.6905L92.7993 143.794Z",
    fill: "black"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M92.5092 141.709H69.7411L69.625 140.783H92.3133L92.5092 141.709Z",
    fill: "#E0E0E0"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M92.0814 139.629H69.3496L69.1465 138.704H91.8855L92.0814 139.629Z",
    fill: "black"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M91.6094 137.544H68.9428L68.6309 136.618H91.428L91.6094 137.544Z",
    fill: "#E0E0E0"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M91.0357 135.464H68.3619L68.0645 134.539H90.6874L91.0357 135.464Z",
    fill: "black"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M90.3471 133.379H67.6661L67.2598 132.453H89.9988L90.3471 133.379Z",
    fill: "#E0E0E0"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M89.5198 131.299H66.7808L66.3672 130.374H89.1643L89.5198 131.299Z",
    fill: "black"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M88.5327 129.214H65.7936L65.293 128.294H88.032L88.5327 129.214Z",
    fill: "#E0E0E0"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M87.3432 127.134H64.6114L64.002 126.209H86.741L87.3432 127.134Z",
    fill: "black"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M85.9055 125.055H63.1737L62.4336 124.129H85.1726L85.9055 125.055Z",
    fill: "#E0E0E0"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M84.1499 122.969H61.4109L60.5039 122.044H83.2937L84.1499 122.969Z",
    fill: "black"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M81.9597 120.89H59.2279L58.0742 119.964H80.806L81.9597 120.89Z",
    fill: "#E0E0E0"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M79.1656 118.804H56.4266L54.9102 117.879H77.642L79.1656 118.804Z",
    fill: "black"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M152.049 115.114H171.254V81.2452L152.049 64.684V115.114Z",
    fill: "url(#paint3_linear_1604_23319)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M152.049 115.114H171.254V81.2452L152.049 64.684V115.114Z",
    fill: "black"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M154.5 115.188H167.901L168.794 83.4604L154.5 71.132V115.188Z",
    fill: "url(#paint4_linear_1604_23319)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M173.858 159.202H149.443V116.145L173.858 95.0977V159.202Z",
    fill: "url(#paint5_linear_1604_23319)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M173.858 159.202H149.443V116.145L173.858 95.0977V159.202Z",
    fill: "black"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M171.254 141.024L152.049 133.366V118.496L171.254 101.935V141.024Z",
    fill: "url(#paint6_linear_1604_23319)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M171.254 159.054H152.049V137.081L171.254 144.849V159.054Z",
    fill: "url(#paint7_linear_1604_23319)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M154.5 159.054H153.463V137.655L154.5 138.074V159.054Z",
    fill: "#E0E0E0"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M169.84 159.054H168.795V143.856L169.84 144.282V159.054Z",
    fill: "#E0E0E0"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M162.17 159.054H161.133V140.758L162.17 141.178V159.054Z",
    fill: "#E0E0E0"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M158.34 159.054H157.295V139.204L158.34 139.629V159.054Z",
    fill: "#E0E0E0"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M166 159.053H164.963V142.307L166 142.727V159.053Z",
    fill: "#E0E0E0"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M154.5 134.347L153.463 133.934V117.274L154.5 116.355V134.347Z",
    fill: "#E0E0E0"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M169.84 140.37L168.795 140.043V104.057L169.84 103.15V140.37Z",
    fill: "#E0E0E0"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M162.17 137.402L161.133 136.988V110.666L162.17 109.765V137.402Z",
    fill: "#E0E0E0"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M158.34 135.878L157.295 135.464V113.973L158.34 113.072V135.878Z",
    fill: "#E0E0E0"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M166 138.932L164.963 138.519V107.346L166 106.464V138.932Z",
    fill: "#E0E0E0"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M156.126 110.388L155.32 111.079V71.8354L156.126 72.5327V110.388Z",
    fill: "#E0E0E0"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M167.981 100.164L167.176 100.855V82.0597L167.981 82.7569V100.164Z",
    fill: "#E0E0E0"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M162.053 105.273L161.248 105.97V76.9507L162.053 77.6418V105.273Z",
    fill: "#E0E0E0"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M159.087 107.827L158.281 108.524V74.39L159.087 75.0872V107.827Z",
    fill: "#E0E0E0"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M165.014 102.718L164.209 103.409V79.5051L165.014 80.2024V102.718Z",
    fill: "#E0E0E0"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M175.012 122.975C175.012 131.114 175.737 144.991 177 159.202H196.554C197.809 145.01 198.542 131.114 198.542 122.975C198.542 101.12 186.773 83.4049 186.773 83.4049C186.773 83.4049 175.012 101.12 175.012 122.975Z",
    fill: "url(#paint8_linear_1604_23319)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M175.012 122.975C175.012 131.114 175.737 144.991 177 159.202H196.554C197.809 145.01 198.542 131.114 198.542 122.975C198.542 101.12 186.773 83.4049 186.773 83.4049C186.773 83.4049 175.012 101.12 175.012 122.975Z",
    fill: "#E0E0E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.793 104.082C195.67 103.625 195.532 103.175 195.401 102.73H178.148C178.017 103.175 177.879 103.625 177.756 104.082H195.793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.896 95.0237H192.658C192.469 94.563 192.281 94.1125 192.092 93.6724H181.462C181.274 94.0919 181.085 94.5424 180.896 95.0237Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.535 122.253C198.535 121.803 198.535 121.346 198.535 120.902H175.049C175.049 121.346 175.049 121.803 175.049 122.253H198.535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.782 113.171C197.709 112.714 197.637 112.264 197.557 111.813H176C175.921 112.264 175.848 112.714 175.775 113.171H197.782Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.338 149.508C197.338 149.051 197.404 148.601 197.433 148.151H176.123C176.123 148.601 176.188 149.051 176.217 149.508H197.338Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.612 158.578C196.648 158.128 196.685 157.677 196.728 157.227H176.826C176.87 157.677 176.906 158.128 176.942 158.578H196.612Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.925 140.419C197.925 139.969 197.976 139.518 198.005 139.068H175.549C175.549 139.518 175.6 139.969 175.629 140.419H197.925Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.361 131.336C198.361 130.88 198.375 130.429 198.404 129.985H175.143C175.143 130.429 175.143 130.88 175.193 131.336H198.361Z",
    fill: "black"
  }))), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M188.559 150.693H185.004V155.524H188.559V150.693Z",
    fill: "url(#paint9_linear_1604_23319)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M188.559 150.693H185.004V155.524H188.559V150.693Z",
    fill: "#E0E0E0"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M182.581 150.693H179.025V155.524H182.581V150.693Z",
    fill: "url(#paint10_linear_1604_23319)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M182.581 150.693H179.025V155.524H182.581V150.693Z",
    fill: "#E0E0E0"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M194.61 150.693H191.055V155.524H194.61V150.693Z",
    fill: "url(#paint11_linear_1604_23319)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M194.61 150.693H191.055V155.524H194.61V150.693Z",
    fill: "#E0E0E0"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M184.452 142.036H180.896V146.867H184.452V142.036Z",
    fill: "url(#paint12_linear_1604_23319)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M184.452 142.036H180.896V146.867H184.452V142.036Z",
    fill: "#E0E0E0"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M192.665 142.036H189.109V146.867H192.665V142.036Z",
    fill: "url(#paint13_linear_1604_23319)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M192.665 142.036H189.109V146.867H192.665V142.036Z",
    fill: "#E0E0E0"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M184.452 123.716H180.896V128.547H184.452V123.716Z",
    fill: "url(#paint14_linear_1604_23319)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M184.452 123.716H180.896V128.547H184.452V123.716Z",
    fill: "#E0E0E0"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M192.665 123.716H189.109V128.547H192.665V123.716Z",
    fill: "url(#paint15_linear_1604_23319)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M192.665 123.716H189.109V128.547H192.665V123.716Z",
    fill: "#E0E0E0"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M184.452 105.396H180.896V110.227H184.452V105.396Z",
    fill: "url(#paint16_linear_1604_23319)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M184.452 105.396H180.896V110.227H184.452V105.396Z",
    fill: "#E0E0E0"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M192.665 105.396H189.109V110.227H192.665V105.396Z",
    fill: "url(#paint17_linear_1604_23319)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M192.665 105.396H189.109V110.227H192.665V105.396Z",
    fill: "#E0E0E0"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M188.559 96.7391H185.004V101.57H188.559V96.7391Z",
    fill: "url(#paint18_linear_1604_23319)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M188.559 96.7391H185.004V101.57H188.559V96.7391Z",
    fill: "#E0E0E0"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M188.559 87.6501H185.004V92.4815H188.559V87.6501Z",
    fill: "url(#paint19_linear_1604_23319)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M188.559 87.6501H185.004V92.4815H188.559V87.6501Z",
    fill: "#E0E0E0"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M188.559 132.879H185.004V137.71H188.559V132.879Z",
    fill: "url(#paint20_linear_1604_23319)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M188.559 132.879H185.004V137.71H188.559V132.879Z",
    fill: "#E0E0E0"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M182.581 132.879H179.025V137.71H182.581V132.879Z",
    fill: "url(#paint21_linear_1604_23319)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M182.581 132.879H179.025V137.71H182.581V132.879Z",
    fill: "#E0E0E0"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M194.61 132.879H191.055V137.71H194.61V132.879Z",
    fill: "url(#paint22_linear_1604_23319)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M194.61 132.879H191.055V137.71H194.61V132.879Z",
    fill: "#E0E0E0"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M188.559 114.559H185.004V119.39H188.559V114.559Z",
    fill: "url(#paint23_linear_1604_23319)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M188.559 114.559H185.004V119.39H188.559V114.559Z",
    fill: "#E0E0E0"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M182.581 114.559H179.025V119.39H182.581V114.559Z",
    fill: "url(#paint24_linear_1604_23319)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M182.581 114.559H179.025V119.39H182.581V114.559Z",
    fill: "#E0E0E0"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M194.61 114.559H191.055V119.39H194.61V114.559Z",
    fill: "url(#paint25_linear_1604_23319)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M194.61 114.559H191.055V119.39H194.61V114.559Z",
    fill: "#E0E0E0"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M212.697 40.4283H202.641V43.279H212.697V40.4283Z",
    fill: "url(#paint26_linear_1604_23319)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M212.697 40.4283H202.641V43.279H212.697V40.4283Z",
    fill: "#E0E0E0"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M207.669 60.2413C223.806 60.2413 236.888 57.3474 236.888 53.7748H178.451C178.451 57.3474 191.533 60.2413 207.669 60.2413Z",
    fill: "url(#paint27_linear_1604_23319)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M207.669 60.2413C223.806 60.2413 236.888 57.3474 236.888 53.7748H178.451C178.451 57.3474 191.533 60.2413 207.669 60.2413Z",
    fill: "#E0E0E0"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M207.669 42.1066C191.533 42.1066 178.451 45.0005 178.451 48.5731H236.888C236.888 45.0005 223.806 42.1066 207.669 42.1066Z",
    fill: "url(#paint28_linear_1604_23319)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M207.669 42.1066C191.533 42.1066 178.451 45.0005 178.451 48.5731H236.888C236.888 45.0005 223.806 42.1066 207.669 42.1066Z",
    fill: "#E0E0E0"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M242.287 49.3568H173.068V52.9973H242.287V49.3568Z",
    fill: "url(#paint29_linear_1604_23319)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M242.287 49.3568H173.068V52.9973H242.287V49.3568Z",
    fill: "#E0E0E0"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M242.287 48.5731H173.068V49.3568H242.287V48.5731Z",
    fill: "url(#paint30_linear_1604_23319)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M242.287 52.9973H173.068V53.781H242.287V52.9973Z",
    fill: "url(#paint31_linear_1604_23319)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M209.309 51.177C209.309 51.4528 209.213 51.7225 209.032 51.9518C208.852 52.1811 208.596 52.3598 208.297 52.4654C207.997 52.5709 207.667 52.5986 207.349 52.5447C207.031 52.4909 206.739 52.3581 206.51 52.1631C206.28 51.9681 206.124 51.7196 206.061 51.4491C205.998 51.1786 206.03 50.8982 206.154 50.6434C206.278 50.3886 206.488 50.1708 206.758 50.0176C207.028 49.8643 207.345 49.7825 207.669 49.7825C208.104 49.7825 208.521 49.9295 208.829 50.191C209.136 50.4525 209.309 50.8072 209.309 51.177Z",
    fill: "url(#paint32_linear_1604_23319)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M209.309 51.177C209.309 51.4528 209.213 51.7225 209.032 51.9518C208.852 52.1811 208.596 52.3598 208.297 52.4654C207.997 52.5709 207.667 52.5986 207.349 52.5447C207.031 52.4909 206.739 52.3581 206.51 52.1631C206.28 51.9681 206.124 51.7196 206.061 51.4491C205.998 51.1786 206.03 50.8982 206.154 50.6434C206.278 50.3886 206.488 50.1708 206.758 50.0176C207.028 49.8643 207.345 49.7825 207.669 49.7825C208.104 49.7825 208.521 49.9295 208.829 50.191C209.136 50.4525 209.309 50.8072 209.309 51.177Z",
    fill: "#E0E0E0"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M239.245 52.5715C240.151 52.5715 240.885 51.9472 240.885 51.177C240.885 50.4069 240.151 49.7825 239.245 49.7825C238.34 49.7825 237.605 50.4069 237.605 51.177C237.605 51.9472 238.34 52.5715 239.245 52.5715Z",
    fill: "url(#paint33_linear_1604_23319)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M239.245 52.5715C240.151 52.5715 240.885 51.9472 240.885 51.177C240.885 50.4069 240.151 49.7825 239.245 49.7825C238.34 49.7825 237.605 50.4069 237.605 51.177C237.605 51.9472 238.34 52.5715 239.245 52.5715Z",
    fill: "#E0E0E0"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M177.334 51.1771C177.334 51.4531 177.238 51.723 177.057 51.9524C176.877 52.1819 176.62 52.3606 176.32 52.466C176.02 52.5713 175.69 52.5986 175.372 52.5443C175.054 52.49 174.761 52.3566 174.532 52.1609C174.303 51.9653 174.148 51.7162 174.085 51.4453C174.023 51.1744 174.056 50.8938 174.182 50.6391C174.307 50.3844 174.518 50.1671 174.789 50.0146C175.059 49.8621 175.377 49.7813 175.702 49.7825C175.917 49.7825 176.13 49.8187 176.328 49.8888C176.527 49.959 176.707 50.0618 176.859 50.1914C177.01 50.3209 177.13 50.4747 177.212 50.6439C177.294 50.813 177.335 50.9942 177.334 51.1771Z",
    fill: "url(#paint34_linear_1604_23319)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M177.334 51.1771C177.334 51.4531 177.238 51.723 177.057 51.9524C176.877 52.1819 176.62 52.3606 176.32 52.466C176.02 52.5713 175.69 52.5986 175.372 52.5443C175.054 52.49 174.761 52.3566 174.532 52.1609C174.303 51.9653 174.148 51.7162 174.085 51.4453C174.023 51.1744 174.056 50.8938 174.182 50.6391C174.307 50.3844 174.518 50.1671 174.789 50.0146C175.059 49.8621 175.377 49.7813 175.702 49.7825C175.917 49.7825 176.13 49.8187 176.328 49.8888C176.527 49.959 176.707 50.0618 176.859 50.1914C177.01 50.3209 177.13 50.4747 177.212 50.6439C177.294 50.813 177.335 50.9942 177.334 51.1771Z",
    fill: "#E0E0E0"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M191.687 52.5715C192.592 52.5715 193.326 51.9472 193.326 51.177C193.326 50.4069 192.592 49.7825 191.687 49.7825C190.781 49.7825 190.047 50.4069 190.047 51.177C190.047 51.9472 190.781 52.5715 191.687 52.5715Z",
    fill: "url(#paint35_linear_1604_23319)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M191.687 52.5715C192.592 52.5715 193.326 51.9472 193.326 51.177C193.326 50.4069 192.592 49.7825 191.687 49.7825C190.781 49.7825 190.047 50.4069 190.047 51.177C190.047 51.9472 190.781 52.5715 191.687 52.5715Z",
    fill: "#E0E0E0"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M223.458 52.5715C224.364 52.5715 225.098 51.9472 225.098 51.177C225.098 50.4069 224.364 49.7825 223.458 49.7825C222.553 49.7825 221.818 50.4069 221.818 51.177C221.818 51.9472 222.553 52.5715 223.458 52.5715Z",
    fill: "url(#paint36_linear_1604_23319)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M223.458 52.5715C224.364 52.5715 225.098 51.9472 225.098 51.177C225.098 50.4069 224.364 49.7825 223.458 49.7825C222.553 49.7825 221.818 50.4069 221.818 51.177C221.818 51.9472 222.553 52.5715 223.458 52.5715Z",
    fill: "#E0E0E0"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M217.203 51.177C217.203 51.4528 217.107 51.7225 216.927 51.9518C216.747 52.1811 216.491 52.3598 216.191 52.4654C215.891 52.5709 215.562 52.5986 215.244 52.5447C214.926 52.4909 214.633 52.3581 214.404 52.1631C214.175 51.9681 214.019 51.7196 213.955 51.4491C213.892 51.1786 213.925 50.8982 214.049 50.6434C214.173 50.3886 214.383 50.1708 214.653 50.0176C214.922 49.8643 215.239 49.7825 215.564 49.7825C215.998 49.7825 216.416 49.9295 216.723 50.191C217.031 50.4525 217.203 50.8072 217.203 51.177Z",
    fill: "url(#paint37_linear_1604_23319)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M217.203 51.177C217.203 51.4528 217.107 51.7225 216.927 51.9518C216.747 52.1811 216.491 52.3598 216.191 52.4654C215.891 52.5709 215.562 52.5986 215.244 52.5447C214.926 52.4909 214.633 52.3581 214.404 52.1631C214.175 51.9681 214.019 51.7196 213.955 51.4491C213.892 51.1786 213.925 50.8982 214.049 50.6434C214.173 50.3886 214.383 50.1708 214.653 50.0176C214.922 49.8643 215.239 49.7825 215.564 49.7825C215.998 49.7825 216.416 49.9295 216.723 50.191C217.031 50.4525 217.203 50.8072 217.203 51.177Z",
    fill: "#E0E0E0"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M232.992 51.177C232.992 51.4528 232.896 51.7225 232.716 51.9518C232.536 52.1811 232.28 52.3598 231.98 52.4654C231.681 52.5709 231.351 52.5986 231.033 52.5447C230.715 52.4909 230.422 52.3581 230.193 52.1631C229.964 51.9681 229.808 51.7196 229.744 51.4491C229.681 51.1786 229.714 50.8982 229.838 50.6434C229.962 50.3886 230.172 50.1708 230.442 50.0176C230.711 49.8643 231.028 49.7825 231.353 49.7825C231.788 49.7825 232.205 49.9295 232.512 50.191C232.82 50.4525 232.992 50.8072 232.992 51.177Z",
    fill: "url(#paint38_linear_1604_23319)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M232.992 51.177C232.992 51.4528 232.896 51.7225 232.716 51.9518C232.536 52.1811 232.28 52.3598 231.98 52.4654C231.681 52.5709 231.351 52.5986 231.033 52.5447C230.715 52.4909 230.422 52.3581 230.193 52.1631C229.964 51.9681 229.808 51.7196 229.744 51.4491C229.681 51.1786 229.714 50.8982 229.838 50.6434C229.962 50.3886 230.172 50.1708 230.442 50.0176C230.711 49.8643 231.028 49.7825 231.353 49.7825C231.788 49.7825 232.205 49.9295 232.512 50.191C232.82 50.4525 232.992 50.8072 232.992 51.177Z",
    fill: "#E0E0E0"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M199.681 52.5715C200.586 52.5715 201.321 51.9472 201.321 51.177C201.321 50.4069 200.586 49.7825 199.681 49.7825C198.775 49.7825 198.041 50.4069 198.041 51.177C198.041 51.9472 198.775 52.5715 199.681 52.5715Z",
    fill: "url(#paint39_linear_1604_23319)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M199.681 52.5715C200.586 52.5715 201.321 51.9472 201.321 51.177C201.321 50.4069 200.586 49.7825 199.681 49.7825C198.775 49.7825 198.041 50.4069 198.041 51.177C198.041 51.9472 198.775 52.5715 199.681 52.5715Z",
    fill: "#E0E0E0"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M185.33 51.177C185.33 51.4528 185.234 51.7225 185.054 51.9518C184.874 52.1811 184.618 52.3598 184.318 52.4654C184.018 52.5709 183.689 52.5986 183.371 52.5447C183.053 52.4909 182.76 52.3581 182.531 52.1631C182.302 51.9681 182.146 51.7196 182.082 51.4491C182.019 51.1786 182.051 50.8982 182.176 50.6434C182.3 50.3886 182.51 50.1708 182.78 50.0176C183.049 49.8643 183.366 49.7825 183.691 49.7825C184.125 49.7825 184.543 49.9295 184.85 50.191C185.158 50.4525 185.33 50.8072 185.33 51.177Z",
    fill: "url(#paint40_linear_1604_23319)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M185.33 51.177C185.33 51.4528 185.234 51.7225 185.054 51.9518C184.874 52.1811 184.618 52.3598 184.318 52.4654C184.018 52.5709 183.689 52.5986 183.371 52.5447C183.053 52.4909 182.76 52.3581 182.531 52.1631C182.302 51.9681 182.146 51.7196 182.082 51.4491C182.019 51.1786 182.051 50.8982 182.176 50.6434C182.3 50.3886 182.51 50.1708 182.78 50.0176C183.049 49.8643 183.366 49.7825 183.691 49.7825C184.125 49.7825 184.543 49.9295 184.85 50.191C185.158 50.4525 185.33 50.8072 185.33 51.177Z",
    fill: "#E0E0E0"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M171.428 51.177C171.43 51.5458 171.603 51.8989 171.911 52.1591C172.218 52.4193 172.634 52.5654 173.067 52.5654V49.7825C172.633 49.7825 172.216 49.9295 171.908 50.191C171.6 50.4525 171.428 50.8072 171.428 51.177Z",
    fill: "url(#paint41_linear_1604_23319)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M171.428 51.177C171.43 51.5458 171.603 51.8989 171.911 52.1591C172.218 52.4193 172.634 52.5654 173.067 52.5654V49.7825C172.633 49.7825 172.216 49.9295 171.908 50.191C171.6 50.4525 171.428 50.8072 171.428 51.177Z",
    fill: "#E0E0E0"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M244.013 51.177C244.011 51.5458 243.837 51.8989 243.53 52.1591C243.223 52.4193 242.807 52.5654 242.373 52.5654V49.7825C242.808 49.7825 243.225 49.9295 243.533 50.191C243.84 50.4525 244.013 50.8072 244.013 51.177Z",
    fill: "url(#paint42_linear_1604_23319)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M244.013 51.177C244.011 51.5458 243.837 51.8989 243.53 52.1591C243.223 52.4193 242.807 52.5654 242.373 52.5654V49.7825C242.808 49.7825 243.225 49.9295 243.533 50.191C243.84 50.4525 244.013 50.8072 244.013 51.177Z",
    fill: "#E0E0E0"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M212.16 63.6782H203.178V159.202H212.16V63.6782Z",
    fill: "url(#paint43_linear_1604_23319)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M212.16 63.6782H203.178V159.202H212.16V63.6782Z",
    fill: "#E0E0E0"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M211.719 64.6655H207.67V68.1086H211.719V64.6655Z",
    fill: "#E0E0E0"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M211.719 154.79H207.67V158.233H211.719V154.79Z",
    fill: "#E0E0E0"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M211.719 109.728H207.67V113.171H211.719V109.728Z",
    fill: "#E0E0E0"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M211.719 87.1935H207.67V90.6366H211.719V87.1935Z",
    fill: "#E0E0E0"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M211.719 132.262H207.67V135.705H211.719V132.262Z",
    fill: "#E0E0E0"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M211.719 143.523H207.67V146.966H211.719V143.523Z",
    fill: "#E0E0E0"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M211.719 120.995H207.67V124.438H211.719V120.995Z",
    fill: "#E0E0E0"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M211.719 98.4606H207.67V101.904H211.719V98.4606Z",
    fill: "#E0E0E0"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M211.719 75.9326H207.67V79.3756H211.719V75.9326Z",
    fill: "#E0E0E0"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M211.719 70.299H207.67V73.742H211.719V70.299Z",
    fill: "#E0E0E0"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M211.719 81.5662H207.67V85.0092H211.719V81.5662Z",
    fill: "#E0E0E0"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M211.719 92.827H207.67V96.2701H211.719V92.827Z",
    fill: "#E0E0E0"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M211.719 104.094H207.67V107.537H211.719V104.094Z",
    fill: "#E0E0E0"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M211.719 115.361H207.67V118.804H211.719V115.361Z",
    fill: "#E0E0E0"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M211.719 126.628H207.67V130.071H211.719V126.628Z",
    fill: "#E0E0E0"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M211.719 137.895H207.67V141.338H211.719V137.895Z",
    fill: "#E0E0E0"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M211.719 149.156H207.67V152.599H211.719V149.156Z",
    fill: "#E0E0E0"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M221.238 59.3528H194.109V63.6783H221.238V59.3528Z",
    fill: "url(#paint44_linear_1604_23319)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M221.238 59.3528H194.109V63.6783H221.238V59.3528Z",
    fill: "#E0E0E0"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M209.136 60.2783H206.219V62.7588H209.136V60.2783Z",
    fill: "#E0E0E0"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M220.12 60.2783H217.203V62.7588H220.12V60.2783Z",
    fill: "#E0E0E0"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M197.969 60.2783H195.053V62.7588H197.969V60.2783Z",
    fill: "#E0E0E0"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M203.382 60.2783H200.465V62.7588H203.382V60.2783Z",
    fill: "#E0E0E0"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M214.628 60.2783H211.711V62.7588H214.628V60.2783Z",
    fill: "#E0E0E0"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M142.499 60.7288H139.234V78.1169H142.499V60.7288Z",
    fill: "url(#paint45_linear_1604_23319)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M142.499 60.7288H139.234V78.1169H142.499V60.7288Z",
    fill: "#E0E0E0"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M142.499 68.5158H139.234V71.2925H142.499V68.5158Z",
    fill: "black"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M147.158 155.592H134.664L138.502 98.115H143.327L147.158 155.592Z",
    fill: "url(#paint46_linear_1604_23319)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M147.158 155.592H134.664L138.502 98.115H143.327L147.158 155.592Z",
    fill: "#E0E0E0"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M142.544 80.7331H139.279V98.1212H142.544V80.7331Z",
    fill: "url(#paint47_linear_1604_23319)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M142.544 80.7331H139.279V98.1212H142.544V80.7331Z",
    fill: "#E0E0E0"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M141.87 39.6014H140.02L140.731 16.1787L141.87 39.6014Z",
    fill: "url(#paint48_linear_1604_23319)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M141.87 39.6014H140.02L140.731 16.1787L141.87 39.6014Z",
    fill: "black"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M140.925 62.8575C147.589 62.8575 152.992 58.2634 152.992 52.5962C152.992 46.9291 147.589 42.3349 140.925 42.3349C134.262 42.3349 128.859 46.9291 128.859 52.5962C128.859 58.2634 134.262 62.8575 140.925 62.8575Z",
    fill: "url(#paint49_linear_1604_23319)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M140.925 62.8575C147.589 62.8575 152.992 58.2634 152.992 52.5962C152.992 46.9291 147.589 42.3349 140.925 42.3349C134.262 42.3349 128.859 46.9291 128.859 52.5962C128.859 58.2634 134.262 62.8575 140.925 62.8575Z",
    fill: "#E0E0E0"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M152.992 51.2264H128.736V53.9661H152.992V51.2264Z",
    fill: "url(#paint50_linear_1604_23319)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M152.992 51.2264H128.736V53.9661H152.992V51.2264Z",
    fill: "black"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M152.992 50.8439H128.736V51.2264H152.992V50.8439Z",
    fill: "url(#paint51_linear_1604_23319)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M152.992 50.8439H128.736V51.2264H152.992V50.8439Z",
    fill: "#E0E0E0"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M148.448 51.7139H147.955V53.9661H148.448V51.7139Z",
    fill: "url(#paint52_linear_1604_23319)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M148.448 51.7139H147.955V53.9661H148.448V51.7139Z",
    fill: "black"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M148.448 51.2264H147.955V51.7077H148.448V51.2264Z",
    fill: "url(#paint53_linear_1604_23319)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M148.448 51.2264H147.955V51.7077H148.448V51.2264Z",
    fill: "black"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M152.992 53.9661H128.736V54.3486H152.992V53.9661Z",
    fill: "url(#paint54_linear_1604_23319)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M152.992 53.9661H128.736V54.3486H152.992V53.9661Z",
    fill: "#E0E0E0"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M145.954 94.9187C145.947 95.7656 145.645 96.5916 145.087 97.2928C144.528 97.9939 143.738 98.5388 142.816 98.8587C141.894 99.1785 140.882 99.259 139.906 99.0901C138.93 98.9212 138.035 98.5103 137.333 97.9094C136.632 97.3084 136.155 96.5443 135.963 95.7132C135.772 94.8822 135.874 94.0216 136.256 93.2397C136.639 92.4579 137.285 91.79 138.114 91.3201C138.942 90.8503 139.916 90.5995 140.912 90.5995C141.577 90.5995 142.236 90.7114 142.85 90.9289C143.464 91.1463 144.021 91.4649 144.49 91.8664C144.959 92.2679 145.33 92.7443 145.581 93.2682C145.832 93.792 145.959 94.353 145.954 94.9187Z",
    fill: "url(#paint55_linear_1604_23319)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M145.954 94.9187C145.947 95.7656 145.645 96.5916 145.087 97.2928C144.528 97.9939 143.738 98.5388 142.816 98.8587C141.894 99.1785 140.882 99.259 139.906 99.0901C138.93 98.9212 138.035 98.5103 137.333 97.9094C136.632 97.3084 136.155 96.5443 135.963 95.7132C135.772 94.8822 135.874 94.0216 136.256 93.2397C136.639 92.4579 137.285 91.79 138.114 91.3201C138.942 90.8503 139.916 90.5995 140.912 90.5995C141.577 90.5995 142.236 90.7114 142.85 90.9289C143.464 91.1463 144.021 91.4649 144.49 91.8664C144.959 92.2679 145.33 92.7443 145.581 93.2682C145.832 93.792 145.959 94.353 145.954 94.9187Z",
    fill: "black"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M141.339 94.3017H140.49V95.5419H141.339V94.3017Z",
    fill: "#E0E0E0"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M142.972 94.3018H142.123V95.542H142.972V94.3018Z",
    fill: "#E0E0E0"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M144.583 94.3017H143.734V95.5419H144.583V94.3017Z",
    fill: "#E0E0E0"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M139.706 94.3017H138.857V95.5419H139.706V94.3017Z",
    fill: "#E0E0E0"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M138.052 94.3017H137.203V95.5419H138.052V94.3017Z",
    fill: "#E0E0E0"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M136.477 95.5358H135.926C135.853 95.1267 135.853 94.7107 135.926 94.3017H136.477V95.5358Z",
    fill: "#E0E0E0"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M145.904 95.5358H145.389V94.3017H145.904C145.969 94.7112 145.969 95.1263 145.904 95.5358Z",
    fill: "#E0E0E0"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M145.613 93.3639H136.217L136.275 93.2405H145.555L145.613 93.3639Z",
    fill: "black"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M145.554 96.5848H136.267L136.209 96.4675H145.612L145.554 96.5848Z",
    fill: "black"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M144.038 76.8643H137.791V80.727H144.038V76.8643Z",
    fill: "url(#paint56_linear_1604_23319)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M144.038 76.8643H137.791V80.727H144.038V76.8643Z",
    fill: "black"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M144.038 77.3764H137.791V77.469H144.038V77.3764Z",
    fill: "black"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M144.038 80.1099H137.791V80.2024H144.038V80.1099Z",
    fill: "black"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M144.038 78.1971H137.791V79.4065H144.038V78.1971Z",
    fill: "black"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M144.901 37.3801H136.949V42.8532H144.901V37.3801Z",
    fill: "url(#paint57_linear_1604_23319)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M144.901 37.3801H136.949V42.8532H144.901V37.3801Z",
    fill: "#E0E0E0"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M148.747 155.592H133.082V159.214H148.747V155.592Z",
    fill: "url(#paint58_linear_1604_23319)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M148.747 155.592H133.082V159.214H148.747V155.592Z",
    fill: "black"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M148.747 158.066H133.082V158.548H148.747V158.066Z",
    fill: "black"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M148.747 156.74H133.082V156.98H148.747V156.74Z",
    fill: "black"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M141.267 99.1887H140.418V155.592H141.267V99.1887Z",
    fill: "black"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M255.505 108.512H230.865V159.14H255.505V108.512Z",
    fill: "#263238"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M255.505 108.512H230.865V159.14H255.505V108.512Z",
    fill: "#E0E0E0"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M230.866 123.043H224.213L230.866 133.212V123.043Z",
    fill: "#263238"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M230.866 123.043H224.213L230.866 133.212V123.043Z",
    fill: "#E0E0E0"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M232.891 121.359H224.213V123.043H232.891V121.359Z",
    fill: "url(#paint59_linear_1604_23319)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M232.891 121.359H224.213V123.043H232.891V121.359Z",
    fill: "#E0E0E0"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M257.479 130.232H244.172V99.3367L257.479 101.25V130.232Z",
    fill: "url(#paint60_linear_1604_23319)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M257.479 130.232H244.172V99.3367L257.479 101.25V130.232Z",
    fill: "#E0E0E0"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M257.479 129.38H244.172V130.423H257.479V129.38Z",
    fill: "url(#paint61_linear_1604_23319)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M257.479 129.38H244.172V130.423H257.479V129.38Z",
    fill: "#E0E0E0"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M257.479 126.894H244.172V127.936H257.479V126.894Z",
    fill: "url(#paint62_linear_1604_23319)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M257.479 126.894H244.172V127.936H257.479V126.894Z",
    fill: "#E0E0E0"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M257.479 124.327H244.172V125.37H257.479V124.327Z",
    fill: "url(#paint63_linear_1604_23319)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M257.479 124.327H244.172V125.37H257.479V124.327Z",
    fill: "#E0E0E0"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M257.479 121.859H244.172V122.901H257.479V121.859Z",
    fill: "url(#paint64_linear_1604_23319)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M257.479 121.859H244.172V122.901H257.479V121.859Z",
    fill: "#E0E0E0"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M257.479 119.298H244.172V120.341H257.479V119.298Z",
    fill: "url(#paint65_linear_1604_23319)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M257.479 119.298H244.172V120.341H257.479V119.298Z",
    fill: "#E0E0E0"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M257.479 116.731H244.172V117.774H257.479V116.731Z",
    fill: "url(#paint66_linear_1604_23319)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M257.479 116.731H244.172V117.774H257.479V116.731Z",
    fill: "#E0E0E0"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M257.479 114.244H244.172V115.287H257.479V114.244Z",
    fill: "url(#paint67_linear_1604_23319)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M257.479 114.244H244.172V115.287H257.479V114.244Z",
    fill: "#E0E0E0"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M257.479 111.684H244.172V112.727H257.479V111.684Z",
    fill: "url(#paint68_linear_1604_23319)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M257.479 111.684H244.172V112.727H257.479V111.684Z",
    fill: "#E0E0E0"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M257.479 109.216H244.172V110.258H257.479V109.216Z",
    fill: "url(#paint69_linear_1604_23319)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M257.479 109.216H244.172V110.258H257.479V109.216Z",
    fill: "#E0E0E0"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M257.479 106.649H244.172V107.691H257.479V106.649Z",
    fill: "url(#paint70_linear_1604_23319)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M257.479 106.649H244.172V107.691H257.479V106.649Z",
    fill: "#E0E0E0"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M256.979 159.072H240.77V131.682H261.259L256.979 159.072Z",
    fill: "url(#paint71_linear_1604_23319)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M256.979 159.072H240.77V131.682H261.259L256.979 159.072Z",
    fill: "#E0E0E0"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M256.979 159.072H240.777V157.869H257.175L256.979 159.072Z",
    fill: "url(#paint72_linear_1604_23319)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M256.979 159.072H240.777V157.869H257.175L256.979 159.072Z",
    fill: "#E0E0E0"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M257.443 156.209H240.777V155.006H257.618L257.443 156.209Z",
    fill: "url(#paint73_linear_1604_23319)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M257.443 156.209H240.777V155.006H257.618L257.443 156.209Z",
    fill: "#E0E0E0"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M257.864 153.253H240.77V152.05H258.074L257.864 153.253Z",
    fill: "url(#paint74_linear_1604_23319)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M257.864 153.253H240.77V152.05H258.074L257.864 153.253Z",
    fill: "#E0E0E0"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M258.343 150.409H240.777V149.206H258.51L258.343 150.409Z",
    fill: "url(#paint75_linear_1604_23319)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M258.343 150.409H240.777V149.206H258.51L258.343 150.409Z",
    fill: "#E0E0E0"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M258.778 147.46H240.77V146.25H258.974L258.778 147.46Z",
    fill: "url(#paint76_linear_1604_23319)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M258.778 147.46H240.77V146.25H258.974L258.778 147.46Z",
    fill: "#E0E0E0"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M259.257 144.504H240.777V143.294H259.431L259.257 144.504Z",
    fill: "url(#paint77_linear_1604_23319)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M259.257 144.504H240.777V143.294H259.431L259.257 144.504Z",
    fill: "#E0E0E0"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M259.714 141.641H240.777V140.438H259.889L259.714 141.641Z",
    fill: "url(#paint78_linear_1604_23319)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M259.714 141.641H240.777V140.438H259.889L259.714 141.641Z",
    fill: "#E0E0E0"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M260.193 138.685H240.77V137.482H260.367L260.193 138.685Z",
    fill: "url(#paint79_linear_1604_23319)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M260.193 138.685H240.77V137.482H260.367L260.193 138.685Z",
    fill: "#E0E0E0"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M260.636 135.841H240.777V134.637H260.788L260.636 135.841Z",
    fill: "url(#paint80_linear_1604_23319)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M260.636 135.841H240.777V134.637H260.788L260.636 135.841Z",
    fill: "#E0E0E0"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M261.114 132.891H240.77V131.682H261.259L261.114 132.891Z",
    fill: "url(#paint81_linear_1604_23319)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M261.114 132.891H240.77V131.682H261.259L261.114 132.891Z",
    fill: "#E0E0E0"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M233.565 140.913H216.479V159.14H233.565V140.913Z",
    fill: "url(#paint82_linear_1604_23319)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M233.565 140.913H216.479V159.14H233.565V140.913Z",
    fill: "#E0E0E0"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M233.565 158.017H216.479V159.14H233.565V158.017Z",
    fill: "url(#paint83_linear_1604_23319)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M233.565 158.017H216.479V159.14H233.565V158.017Z",
    fill: "#E0E0E0"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M233.565 153.975H216.479V154.932H233.565V153.975Z",
    fill: "url(#paint84_linear_1604_23319)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M233.565 153.975H216.479V154.932H233.565V153.975Z",
    fill: "#E0E0E0"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M233.565 151.698H216.479V152.655H233.565V151.698Z",
    fill: "url(#paint85_linear_1604_23319)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M233.565 151.698H216.479V152.655H233.565V151.698Z",
    fill: "#E0E0E0"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M233.565 149.348H216.479V150.304H233.565V149.348Z",
    fill: "url(#paint86_linear_1604_23319)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M233.565 149.348H216.479V150.304H233.565V149.348Z",
    fill: "#E0E0E0"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M233.565 147.083H216.479V148.039H233.565V147.083Z",
    fill: "url(#paint87_linear_1604_23319)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M233.565 147.083H216.479V148.039H233.565V147.083Z",
    fill: "#E0E0E0"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M233.565 144.732H216.479V145.689H233.565V144.732Z",
    fill: "url(#paint88_linear_1604_23319)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M233.565 144.732H216.479V145.689H233.565V144.732Z",
    fill: "#E0E0E0"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M233.565 140.913H216.479V141.474H233.565V140.913Z",
    fill: "url(#paint89_linear_1604_23319)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M233.565 140.913H216.479V141.474H233.565V140.913Z",
    fill: "#E0E0E0"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M233.565 123.043H216.479V141.271H233.565V123.043Z",
    fill: "url(#paint90_linear_1604_23319)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M233.565 123.043H216.479V141.271H233.565V123.043Z",
    fill: "#E0E0E0"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M233.565 140.154H216.479V141.277H233.565V140.154Z",
    fill: "url(#paint91_linear_1604_23319)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M233.565 140.154H216.479V141.277H233.565V140.154Z",
    fill: "#E0E0E0"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M233.565 136.106H216.479V137.062H233.565V136.106Z",
    fill: "url(#paint92_linear_1604_23319)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M233.565 136.106H216.479V137.062H233.565V136.106Z",
    fill: "#E0E0E0"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M233.565 133.829H216.479V134.786H233.565V133.829Z",
    fill: "url(#paint93_linear_1604_23319)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M233.565 133.829H216.479V134.786H233.565V133.829Z",
    fill: "#E0E0E0"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M233.565 131.478H216.479V132.435H233.565V131.478Z",
    fill: "url(#paint94_linear_1604_23319)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M233.565 131.478H216.479V132.435H233.565V131.478Z",
    fill: "#E0E0E0"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M233.565 129.22H216.479V130.176H233.565V129.22Z",
    fill: "url(#paint95_linear_1604_23319)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M233.565 129.22H216.479V130.176H233.565V129.22Z",
    fill: "#E0E0E0"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M233.565 126.863H216.479V127.819H233.565V126.863Z",
    fill: "url(#paint96_linear_1604_23319)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M233.565 126.863H216.479V127.819H233.565V126.863Z",
    fill: "#E0E0E0"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M233.565 123.043H216.479V123.605H233.565V123.043Z",
    fill: "url(#paint97_linear_1604_23319)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M233.565 123.043H216.479V123.605H233.565V123.043Z",
    fill: "#E0E0E0"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M228.884 86.9467H228.166L228.522 69.2068L228.884 86.9467Z",
    fill: "url(#paint98_linear_1604_23319)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M228.884 86.9467H228.166L228.522 69.2068L228.884 86.9467Z",
    fill: "#E0E0E0"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M232.847 90.1614H224.213V123.043H232.847V90.1614Z",
    fill: "url(#paint99_linear_1604_23319)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M232.84 90.1614H224.213C224.213 90.1614 224.213 86.6689 228.523 86.6689C232.833 86.6689 232.84 90.1614 232.84 90.1614Z",
    fill: "#263238"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M232.84 90.1614H224.213C224.213 90.1614 224.213 86.6689 228.523 86.6689C232.833 86.6689 232.84 90.1614 232.84 90.1614Z",
    fill: "#E0E0E0"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M232.847 90.1614H224.213V123.043H232.847V90.1614Z",
    fill: "#E0E0E0"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M232.891 118.453H224.213V120.137H232.891V118.453Z",
    fill: "url(#paint100_linear_1604_23319)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M232.891 118.453H224.213V120.137H232.891V118.453Z",
    fill: "#E0E0E0"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M232.891 115.546H224.213V117.231H232.891V115.546Z",
    fill: "url(#paint101_linear_1604_23319)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M232.891 115.546H224.213V117.231H232.891V115.546Z",
    fill: "#E0E0E0"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M232.891 112.72H224.213V114.405H232.891V112.72Z",
    fill: "url(#paint102_linear_1604_23319)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M232.891 112.72H224.213V114.405H232.891V112.72Z",
    fill: "#E0E0E0"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M232.891 109.888H224.213V111.573H232.891V109.888Z",
    fill: "url(#paint103_linear_1604_23319)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M232.891 109.888H224.213V111.573H232.891V109.888Z",
    fill: "#E0E0E0"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M232.891 107.062H224.213V108.747H232.891V107.062Z",
    fill: "url(#paint104_linear_1604_23319)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M232.891 107.062H224.213V108.747H232.891V107.062Z",
    fill: "#E0E0E0"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M232.891 104.156H224.213V105.84H232.891V104.156Z",
    fill: "url(#paint105_linear_1604_23319)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M232.891 104.156H224.213V105.84H232.891V104.156Z",
    fill: "#E0E0E0"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M232.891 101.25H224.213V102.934H232.891V101.25Z",
    fill: "url(#paint106_linear_1604_23319)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M232.891 101.25H224.213V102.934H232.891V101.25Z",
    fill: "#E0E0E0"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M232.891 95.3569H224.213V96.048H232.891V95.3569Z",
    fill: "url(#paint107_linear_1604_23319)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M232.891 95.3569H224.213V96.048H232.891V95.3569Z",
    fill: "#E0E0E0"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M222.263 85.6263H227.131L227.857 85.1758V83.8184H223.793C223.189 83.8412 222.597 83.971 222.055 84.1995C221.512 84.4279 221.032 84.7499 220.645 85.145C221.104 85.4574 221.675 85.6272 222.263 85.6263Z",
    fill: "#263238"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4507 83.5406H104.705L105.619 82.9545V81.2083H100.388C98.3999 81.2083 97.2245 82.1832 96.332 82.9174C96.9323 83.3271 97.681 83.5474 98.4507 83.5406Z",
    fill: "#263238"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M246.96 85.6262H252.525L253.337 84.7253V82.0042H248.686C246.923 82.0042 245.871 83.5221 245.059 84.6636C245.259 84.944 245.537 85.1784 245.868 85.3462C246.2 85.5141 246.574 85.6102 246.96 85.6262Z",
    fill: "#263238"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M192.629 76.3522H200.197L200.922 75.8956V74.5381H194.153C193.548 74.561 192.956 74.6908 192.414 74.9192C191.872 75.1476 191.392 75.4696 191.004 75.8647C191.464 76.1806 192.038 76.3527 192.629 76.3522Z",
    fill: "#263238"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M171.4 83.6394H176.261L176.987 82.9545V80.8997H171.052C169.506 80.8997 169.862 81.6525 169.768 82.9051C169.957 83.124 170.203 83.3037 170.485 83.4309C170.768 83.558 171.081 83.6293 171.4 83.6394Z",
    fill: "#263238"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M132.51 85.6818H139.272L139.998 85.2313V83.8738H134.034C133.429 83.8967 132.837 84.0265 132.295 84.2549C131.753 84.4834 131.272 84.8054 130.885 85.2005C131.346 85.5142 131.92 85.684 132.51 85.6818Z",
    fill: "#263238"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1135 88.9582H69.2556L69.9812 88.5078V87.1503H61.6372C61.0327 87.1732 60.4405 87.303 59.8983 87.5314C59.3562 87.7598 58.8759 88.0819 58.4883 88.477C58.9494 88.7907 59.523 88.9605 60.1135 88.9582Z",
    fill: "#263238"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1614 112.554H51.2468L50.2383 111.937V110.005H56.0428C58.2194 110.005 59.5472 111.079 60.5267 111.893C59.8528 112.341 59.0162 112.575 58.1614 112.554Z",
    fill: "#263238"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3075 122.309H82.4463L81.7207 121.852V120.495H85.7838C86.3896 120.517 86.9832 120.646 87.5267 120.875C88.0702 121.103 88.5516 121.426 88.94 121.822C88.4788 122.14 87.9017 122.313 87.3075 122.309Z",
    fill: "#263238"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M161.366 121.704H156.505L155.779 120.47V119.853H159.842C161.388 119.853 162.309 119.853 162.999 120.421C162.665 120.742 161.99 121.704 161.366 121.704Z",
    fill: "#263238"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M252.016 121.593H244.34L243.223 120.625V117.725H249.637C252.074 117.725 253.526 119.347 254.614 120.563C254.291 120.88 253.892 121.136 253.444 121.314C252.997 121.491 252.51 121.587 252.016 121.593Z",
    fill: "#263238"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M226.558 116.527H221.696L220.971 116.077V114.719H225.034C225.638 114.742 226.231 114.872 226.773 115.101C227.315 115.329 227.795 115.651 228.183 116.046C227.722 116.36 227.148 116.53 226.558 116.527Z",
    fill: "#263238"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M195.538 114.318H188.333L187.281 113.344V110.45H193.303C195.589 110.45 196.931 112.079 197.969 113.307C197.676 113.617 197.306 113.868 196.886 114.043C196.466 114.218 196.006 114.312 195.538 114.318Z",
    fill: "#263238"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M106.774 114.997H101.913L101.188 114.547V113.189H105.251C105.856 113.211 106.45 113.341 106.993 113.569C107.537 113.798 108.018 114.12 108.407 114.516C107.943 114.83 107.367 114.999 106.774 114.997Z",
    fill: "#263238"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M133.75 118.058H124.485L123.621 117.509V115.849H131.943C133.83 115.849 134.512 116.651 134.512 117.496C134.055 117.854 134.504 118.058 133.75 118.058Z",
    fill: "#263238"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M293.976 213.803H15.4551V227.242H293.976V213.803Z",
    fill: "url(#paint108_linear_1604_23319)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M293.976 213.803H15.4551V227.242H293.976V213.803Z",
    fill: "#E0E0E0"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4565 223.299H23.8783C23.0124 223.299 22.1819 223.007 21.5696 222.486C20.9573 221.965 20.6133 221.259 20.6133 220.523C20.6133 219.786 20.9573 219.08 21.5696 218.559C22.1819 218.039 23.0124 217.746 23.8783 217.746H45.4565C46.3224 217.746 47.1529 218.039 47.7652 218.559C48.3775 219.08 48.7215 219.786 48.7215 220.523C48.7215 221.259 48.3775 221.965 47.7652 222.486C47.1529 223.007 46.3224 223.299 45.4565 223.299Z",
    fill: "#E0E0E0"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M285.669 223.299H264.091C263.225 223.299 262.395 223.007 261.782 222.486C261.17 221.965 260.826 221.259 260.826 220.523C260.826 219.786 261.17 219.08 261.782 218.559C262.395 218.039 263.225 217.746 264.091 217.746H285.669C286.535 217.746 287.366 218.039 287.978 218.559C288.59 219.08 288.934 219.786 288.934 220.523C288.934 221.259 288.59 221.965 287.978 222.486C287.366 223.007 286.535 223.299 285.669 223.299Z",
    fill: "#E0E0E0"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M164.051 223.299H142.48C141.614 223.299 140.783 223.007 140.171 222.486C139.559 221.965 139.215 221.259 139.215 220.523C139.215 219.786 139.559 219.08 140.171 218.559C140.783 218.039 141.614 217.746 142.48 217.746H164.051C164.917 217.746 165.747 218.039 166.359 218.559C166.972 219.08 167.316 219.786 167.316 220.523C167.316 221.259 166.972 221.965 166.359 222.486C165.747 223.007 164.917 223.299 164.051 223.299Z",
    fill: "#E0E0E0"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8691 223.299H63.2982C62.4323 223.299 61.6018 223.007 60.9895 222.486C60.3772 221.965 60.0332 221.259 60.0332 220.523C60.0332 219.786 60.3772 219.08 60.9895 218.559C61.6018 218.039 62.4323 217.746 63.2982 217.746H84.8691C85.7351 217.746 86.5655 218.039 87.1779 218.559C87.7902 219.08 88.1341 219.786 88.1341 220.523C88.1341 221.259 87.7902 221.965 87.1779 222.486C86.5655 223.007 85.7351 223.299 84.8691 223.299Z",
    fill: "#E0E0E0"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M204.986 223.299H183.408C182.542 223.299 181.711 223.007 181.099 222.486C180.487 221.965 180.143 221.259 180.143 220.523C180.143 219.786 180.487 219.08 181.099 218.559C181.711 218.039 182.542 217.746 183.408 217.746H204.986C205.852 217.746 206.682 218.039 207.294 218.559C207.907 219.08 208.251 219.786 208.251 220.523C208.251 221.259 207.907 221.965 207.294 222.486C206.682 223.007 205.852 223.299 204.986 223.299Z",
    fill: "#E0E0E0"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M244.812 223.299H223.234C222.368 223.299 221.537 223.007 220.925 222.486C220.313 221.965 219.969 221.259 219.969 220.523C219.969 219.786 220.313 219.08 220.925 218.559C221.537 218.039 222.368 217.746 223.234 217.746H244.812C245.678 217.746 246.508 218.039 247.121 218.559C247.733 219.08 248.077 219.786 248.077 220.523C248.077 221.259 247.733 221.965 247.121 222.486C246.508 223.007 245.678 223.299 244.812 223.299Z",
    fill: "#E0E0E0"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M124.732 223.299H103.154C102.288 223.299 101.457 223.007 100.845 222.486C100.233 221.965 99.8887 221.259 99.8887 220.523C99.8887 219.786 100.233 219.08 100.845 218.559C101.457 218.039 102.288 217.746 103.154 217.746H124.732C125.598 217.746 126.428 218.039 127.041 218.559C127.653 219.08 127.997 219.786 127.997 220.523C127.997 221.259 127.653 221.965 127.041 222.486C126.428 223.007 125.598 223.299 124.732 223.299Z",
    fill: "#E0E0E0"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M283.79 187.166H26.8477V194.712H283.79V187.166Z",
    fill: "url(#paint109_linear_1604_23319)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M283.79 187.166H26.8477V194.712H283.79V187.166Z",
    fill: "#E0E0E0"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6905 192.479H36.2787C35.7977 192.479 35.3363 192.316 34.9961 192.027C34.6559 191.737 34.4648 191.345 34.4648 190.936C34.4648 190.527 34.6559 190.134 34.9961 189.845C35.3363 189.556 35.7977 189.393 36.2787 189.393H46.6905C47.1716 189.393 47.633 189.556 47.9732 189.845C48.3133 190.134 48.5044 190.527 48.5044 190.936C48.5044 191.345 48.3133 191.737 47.9732 192.027C47.633 192.316 47.1716 192.479 46.6905 192.479Z",
    fill: "#E0E0E0"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2184 192.479H64.8139C64.3328 192.479 63.8714 192.316 63.5313 192.027C63.1911 191.737 63 191.345 63 190.936C63 190.527 63.1911 190.134 63.5313 189.845C63.8714 189.556 64.3328 189.393 64.8139 189.393H75.2184C75.6995 189.393 76.1609 189.556 76.5011 189.845C76.8412 190.134 77.0323 190.527 77.0323 190.936C77.0323 191.345 76.8412 191.737 76.5011 192.027C76.1609 192.316 75.6995 192.479 75.2184 192.479Z",
    fill: "#E0E0E0"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M131.581 192.479H121.169C120.688 192.479 120.227 192.316 119.887 192.027C119.547 191.737 119.355 191.345 119.355 190.936C119.355 190.527 119.547 190.134 119.887 189.845C120.227 189.556 120.688 189.393 121.169 189.393H131.581C132.062 189.393 132.524 189.556 132.864 189.845C133.204 190.134 133.395 190.527 133.395 190.936C133.395 191.345 133.204 191.737 132.864 192.027C132.524 192.316 132.062 192.479 131.581 192.479Z",
    fill: "#E0E0E0"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M104.089 192.479H93.6772C93.1961 192.479 92.7347 192.316 92.3946 192.027C92.0544 191.737 91.8633 191.345 91.8633 190.936C91.8633 190.527 92.0544 190.134 92.3946 189.845C92.7347 189.556 93.1961 189.393 93.6772 189.393H104.089C104.57 189.393 105.031 189.556 105.372 189.845C105.712 190.134 105.903 190.527 105.903 190.936C105.903 191.345 105.712 191.737 105.372 192.027C105.031 192.316 104.57 192.479 104.089 192.479Z",
    fill: "#E0E0E0"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M161.816 192.479H151.404C150.923 192.479 150.461 192.316 150.121 192.027C149.781 191.737 149.59 191.345 149.59 190.936C149.59 190.527 149.781 190.134 150.121 189.845C150.461 189.556 150.923 189.393 151.404 189.393H161.816C162.297 189.393 162.758 189.556 163.098 189.845C163.438 190.134 163.629 190.527 163.629 190.936C163.629 191.345 163.438 191.737 163.098 192.027C162.758 192.316 162.297 192.479 161.816 192.479Z",
    fill: "#E0E0E0"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M190.351 192.479H179.939C179.458 192.479 178.996 192.316 178.656 192.027C178.316 191.737 178.125 191.345 178.125 190.936C178.125 190.527 178.316 190.134 178.656 189.845C178.996 189.556 179.458 189.393 179.939 189.393H190.351C190.832 189.393 191.293 189.556 191.633 189.845C191.973 190.134 192.165 190.527 192.165 190.936C192.165 191.345 191.973 191.737 191.633 192.027C191.293 192.316 190.832 192.479 190.351 192.479Z",
    fill: "#E0E0E0"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M246.706 192.479H236.294C235.813 192.479 235.352 192.316 235.012 192.027C234.672 191.737 234.48 191.345 234.48 190.936C234.48 190.527 234.672 190.134 235.012 189.845C235.352 189.556 235.813 189.393 236.294 189.393H246.706C247.187 189.393 247.649 189.556 247.989 189.845C248.329 190.134 248.52 190.527 248.52 190.936C248.52 191.345 248.329 191.737 247.989 192.027C247.649 192.316 247.187 192.479 246.706 192.479Z",
    fill: "#E0E0E0"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M273.841 192.479H263.429C262.948 192.479 262.487 192.316 262.147 192.027C261.806 191.737 261.615 191.345 261.615 190.936C261.615 190.527 261.806 190.134 262.147 189.845C262.487 189.556 262.948 189.393 263.429 189.393H273.841C274.322 189.393 274.783 189.556 275.124 189.845C275.464 190.134 275.655 190.527 275.655 190.936C275.655 191.345 275.464 191.737 275.124 192.027C274.783 192.316 274.322 192.479 273.841 192.479Z",
    fill: "#E0E0E0"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M219.214 192.479H208.802C208.321 192.479 207.86 192.316 207.52 192.027C207.179 191.737 206.988 191.345 206.988 190.936C206.988 190.527 207.179 190.134 207.52 189.845C207.86 189.556 208.321 189.393 208.802 189.393H219.214C219.695 189.393 220.156 189.556 220.497 189.845C220.837 190.134 221.028 190.527 221.028 190.936C221.028 191.345 220.837 191.737 220.497 192.027C220.156 192.316 219.695 192.479 219.214 192.479Z",
    fill: "#E0E0E0"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M128.309 174.739L127.707 179.039L121.083 182.007H64.5543L54.8608 178.373L52.9961 170.129L96.1016 164.804L128.309 174.739Z",
    fill: "#263238"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M128.317 174.739C123.282 173.788 120.336 172.888 114.045 172.69L53.0039 170.129L96.1094 164.804L128.317 174.739Z",
    fill: "#E0E0E0"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8616 165.625L81.5898 167.47V170.642L116.932 171.925L95.8616 165.625Z",
    fill: "#263238"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M123.195 180.113L120.721 180.317L117.412 176.17L108.836 176.213L105.012 180.317H73.8858L70.5555 174.301L61.5223 173.887L59.0191 178.015L54.6875 177.583L54.8616 178.373L64.5551 182.007H121.084L127.708 179.039L123.195 180.113Z",
    fill: "black"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M55.4847 171.999L56.7399 177.787L54.6866 177.583L53.4023 171.925L55.4847 171.999Z",
    fill: "#E0E0E0"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M125.241 174.128L124.639 178.786L127.708 179.039L128.31 174.739L125.241 174.128Z",
    fill: "url(#paint110_linear_1604_23319)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M125.241 174.128L124.639 178.786L127.708 179.039L128.31 174.739L125.241 174.128Z",
    fill: "#E0E0E0"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4848 171.999L55.18 170.222L52.9961 170.129L53.4024 171.925L55.4848 171.999Z",
    fill: "url(#paint111_linear_1604_23319)"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M55.4848 171.999L55.18 170.222L52.9961 170.129L53.4024 171.925L55.4848 171.999Z",
    fill: "#E0E0E0"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M106.332 176.911L107.536 176.503H118.913L120.118 176.911V181.261L118.913 181.674H107.536L106.332 181.261V176.911Z",
    fill: "#263238"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M106.332 176.911L107.536 176.503H118.913L120.118 176.911V181.261L118.913 181.674H107.536L106.332 181.261V176.911Z",
    fill: "#E0E0E0"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M106.339 181.261H120.125V176.911H106.339V181.261Z",
    fill: "#263238"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M106.339 181.261H120.125V176.911H106.339V181.261Z",
    fill: "#E0E0E0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.118 179.039H106.332V179.138H120.118V179.039Z",
    fill: "black"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.447 178.749L118.268 178.367C118.914 178.225 119.335 177.398 119.335 176.911H119.219C119.219 177.373 118.812 178.145 118.239 178.268L116.418 178.657L116.447 178.749Z",
    fill: "black"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.629 178.75L113.45 178.367C113.77 178.232 114.04 178.025 114.229 177.768C114.419 177.511 114.521 177.214 114.524 176.911H114.408C114.408 177.374 113.995 178.145 113.429 178.268L111.607 178.657L111.629 178.75Z",
    fill: "black"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.773 178.749L108.594 178.367C108.912 178.231 109.18 178.023 109.368 177.766C109.556 177.509 109.658 177.213 109.661 176.911H109.545C109.545 177.373 109.131 178.145 108.565 178.268L106.744 178.657L106.773 178.749Z",
    fill: "black"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.066 179.422L115.887 179.805C116.205 179.941 116.473 180.148 116.661 180.405C116.849 180.662 116.95 180.958 116.954 181.261H116.838C116.838 180.798 116.424 180.027 115.858 179.903L114.037 179.521L114.066 179.422Z",
    fill: "black"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.56 179.422L111.381 179.805C112.027 179.946 112.448 180.773 112.448 181.261H112.353C112.353 180.798 111.947 180.027 111.374 179.903L109.553 179.521L109.56 179.422Z",
    fill: "black"
  }))), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6504 175.615L60.8548 175.201H72.2316L73.436 175.615V179.965L72.2316 180.372H60.8548L59.6504 179.965V175.615Z",
    fill: "#263238"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M59.6504 175.615L60.8548 175.201H72.2316L73.436 175.615V179.965L72.2316 180.372H60.8548L59.6504 179.965V175.615Z",
    fill: "#E0E0E0"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6499 179.959H73.4355V175.609H59.6499V179.959Z",
    fill: "#263238"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M59.6499 179.959H73.4355V175.609H59.6499V179.959Z",
    fill: "#E0E0E0"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.436 177.738H59.6504V177.836H73.436V177.738Z",
    fill: "black"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.7654 177.454L71.5865 177.065C72.225 176.929 72.6531 176.096 72.6531 175.615H72.537C72.537 176.071 72.1234 176.849 71.5575 176.972L69.7363 177.355L69.7654 177.454Z",
    fill: "black"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.9743 177.454L66.7955 177.065C67.434 176.929 67.8621 176.096 67.8621 175.615H67.746C67.746 176.071 67.3324 176.849 66.7665 176.972L64.9453 177.355L64.9743 177.454Z",
    fill: "black"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.113 177.454L61.9342 177.065C62.5799 176.929 63.0007 176.096 63.0007 175.615H62.8846C62.8846 176.071 62.4783 176.849 61.9051 176.972L60.084 177.355L60.113 177.454Z",
    fill: "black"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.3689 178.126L69.19 178.509C69.8358 178.651 70.2566 179.478 70.2566 179.965H70.1405C70.1405 179.502 69.7342 178.731 69.161 178.601L67.3398 178.219L67.3689 178.126Z",
    fill: "black"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.8786 178.126L64.6998 178.509C65.0177 178.645 65.2854 178.853 65.4736 179.11C65.6617 179.366 65.763 179.662 65.7664 179.965H65.6503C65.6503 179.502 65.2367 178.731 64.6708 178.601L62.8496 178.219L62.8786 178.126Z",
    fill: "black"
  }))), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M124.638 178.786L124.471 179.811L127.707 179.039L124.638 178.786Z",
    fill: "#263238"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M124.638 178.786L124.471 179.811L127.707 179.039L124.638 178.786Z",
    fill: "#E0E0E0"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M125.137 174.109L124.637 178.786L124.47 179.811L123.193 180.113L120.719 180.317L117.432 176.17L108.856 176.213L105.032 180.317H73.8983L70.568 174.301L61.5348 173.887L59.0316 178.015L56.7533 177.787L55.4981 171.999L55.1934 170.222L114.051 172.69C117.797 172.807 121.516 173.283 125.137 174.109Z",
    fill: "#263238"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M125.137 174.109L124.637 178.786L124.47 179.811L123.193 180.113L120.719 180.317L117.432 176.17L108.856 176.213L105.032 180.317H73.8983L70.568 174.301L61.5348 173.887L59.0316 178.015L56.7533 177.787L55.4981 171.999L55.1934 170.222L114.051 172.69C117.797 172.807 121.516 173.283 125.137 174.109Z",
    fill: "#E0E0E0"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M81.5898 167.47V180.372L94.6572 180.317V165.779L81.5898 167.47Z",
    fill: "black"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M108.204 168.537V175.979L104.09 180.341L94.6582 180.317V164.983L96.1021 164.804L108.204 168.537Z",
    fill: "black"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M129.912 197.989L130.855 204.745L141.267 209.416H230.134L245.371 203.702L248.302 190.745L180.542 182.371L129.912 197.989Z",
    fill: "#263238"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M129.912 197.989C137.828 196.495 142.501 195.088 152.339 194.768L248.302 190.745L180.556 182.371L129.912 197.989Z",
    fill: "#E0E0E0"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M180.919 183.661L203.353 186.561V191.547L147.797 193.558L180.919 183.661Z",
    fill: "#263238"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M137.959 206.436L141.833 206.757L147.035 200.241L160.516 200.309L166.539 206.757H215.463L220.709 197.291L234.901 196.65L238.841 203.135L245.654 202.462L245.371 203.702L230.134 209.416H141.267L130.855 204.745L137.959 206.436Z",
    fill: "black"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M244.391 193.682L242.418 202.783L245.654 202.462L247.664 193.558L244.391 193.682Z",
    fill: "#E0E0E0"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M134.73 197.032L135.688 204.35L130.855 204.751L129.912 197.989L134.73 197.032Z",
    fill: "url(#paint112_linear_1604_23319)"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M134.73 197.032L135.688 204.35L130.855 204.751L129.912 197.989L134.73 197.032Z",
    fill: "#E0E0E0"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M244.391 193.682L244.869 190.887L248.301 190.745L247.663 193.558L244.391 193.682Z",
    fill: "url(#paint113_linear_1604_23319)"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M244.391 193.682L244.869 190.887L248.301 190.745L247.663 193.558L244.391 193.682Z",
    fill: "#E0E0E0"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M164.456 201.401L162.562 200.759H144.677L142.783 201.401V208.244L144.677 208.885H162.562L164.456 208.244V201.401Z",
    fill: "#263238"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M164.456 201.401L162.562 200.759H144.677L142.783 201.401V208.244L144.677 208.885H162.562L164.456 208.244V201.401Z",
    fill: "#E0E0E0"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M164.456 201.401H142.783V208.244H164.456V201.401Z",
    fill: "#263238"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M164.456 201.401H142.783V208.244H164.456V201.401Z",
    fill: "#E0E0E0"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.456 204.745H142.783V204.899H164.456V204.745Z",
    fill: "black"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.561 204.295L145.658 203.678C144.65 203.456 143.982 202.154 143.982 201.388H144.164C144.164 202.117 144.81 203.332 145.702 203.53L148.604 204.147L148.561 204.295Z",
    fill: "black"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.084 204.295L153.182 203.678C152.173 203.456 151.506 202.154 151.506 201.388H151.687C151.687 202.117 152.333 203.332 153.225 203.53L156.128 204.147L156.084 204.295Z",
    fill: "black"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.767 204.295L160.901 203.678C159.892 203.455 159.225 202.154 159.225 201.388H159.406C159.406 202.117 160.052 203.332 160.951 203.53L163.81 204.147L163.767 204.295Z",
    fill: "black"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.304 205.35L149.438 205.967C148.429 206.189 147.762 207.491 147.762 208.256H147.943C147.943 207.528 148.589 206.312 149.489 206.115L152.347 205.498L152.304 205.35Z",
    fill: "black"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.377 205.35L156.518 205.967C155.509 206.189 154.842 207.491 154.842 208.256H155.023C155.023 207.528 155.669 206.312 156.561 206.115L159.42 205.498L159.377 205.35Z",
    fill: "black"
  }))), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M237.846 199.358L235.953 198.717H218.068L216.174 199.358V206.201L218.068 206.843H235.953L237.846 206.201V199.358Z",
    fill: "#263238"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M237.846 199.358L235.953 198.717H218.068L216.174 199.358V206.201L218.068 206.843H235.953L237.846 206.201V199.358Z",
    fill: "#E0E0E0"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M237.846 199.358H216.174V206.201H237.846V199.358Z",
    fill: "#263238"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M237.846 199.358H216.174V206.201H237.846V199.358Z",
    fill: "#E0E0E0"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.846 202.703H216.174V202.857H237.846V202.703Z",
    fill: "black"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.95 202.252L219.084 201.635C218.076 201.413 217.408 200.111 217.408 199.346H217.561C217.561 200.074 218.206 201.29 219.106 201.487L221.965 202.104L221.95 202.252Z",
    fill: "black"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.474 202.252L226.608 201.635C225.599 201.413 224.932 200.111 224.932 199.346H225.113C225.113 200.074 225.759 201.29 226.658 201.487L229.517 202.104L229.474 202.252Z",
    fill: "black"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.149 202.252L234.291 201.635C233.282 201.413 232.607 200.111 232.607 199.346H232.796C232.796 200.074 233.442 201.29 234.342 201.487L237.2 202.104L237.149 202.252Z",
    fill: "black"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.694 203.307L222.836 203.924C221.827 204.147 221.152 205.449 221.152 206.214H221.334C221.334 205.486 221.987 204.27 222.879 204.079L225.738 203.462L225.694 203.307Z",
    fill: "black"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.797 203.307L229.895 203.924C228.886 204.147 228.219 205.449 228.219 206.214H228.444C228.444 205.486 229.089 204.27 229.982 204.079L232.848 203.462L232.797 203.307Z",
    fill: "black"
  }))), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M135.688 204.344L135.949 205.955L130.855 204.745L135.688 204.344Z",
    fill: "#263238"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M135.688 204.344L135.949 205.955L130.855 204.745L135.688 204.344Z",
    fill: "#E0E0E0"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M134.889 196.995L135.687 204.35L135.948 205.961L137.958 206.436L141.832 206.757L147.035 200.241L160.515 200.302L166.538 206.757H215.462L220.708 197.291L234.9 196.674L238.84 203.159L242.417 202.808L244.405 193.682L244.884 190.886L152.353 194.768C146.452 194.952 140.594 195.699 134.889 196.995Z",
    fill: "#263238"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M134.889 196.995L135.687 204.35L135.948 205.961L137.958 206.436L141.832 206.757L147.035 200.241L160.515 200.302L166.538 206.757H215.462L220.708 197.291L234.9 196.674L238.84 203.159L242.417 202.808L244.405 193.682L244.884 190.886L152.353 194.768C146.452 194.952 140.594 195.699 134.889 196.995Z",
    fill: "#E0E0E0"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M203.353 186.561V206.843L182.812 206.757V183.908L203.353 186.561Z",
    fill: "black"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M161.518 188.239V199.938L167.982 206.8L182.813 206.757V182.655L180.542 182.371L161.518 188.239Z",
    fill: "#263238"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M167.983 206.8H182.814L182.835 205.664L166.873 205.64L167.983 206.8Z",
    fill: "black"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M161.518 189.461L180.919 183.661L182.813 183.908V182.655L180.542 182.371L161.518 188.239V189.461Z",
    fill: "black"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M161.518 189.461V199.938L166.872 205.64L182.835 205.665L182.813 183.908L180.919 183.661L161.518 189.461Z",
    fill: "#E0E0E0"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M182.152 192.688H181.811V193.626H182.152V192.688Z",
    fill: "#263238"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M182.152 192.688H181.811V193.626H182.152V192.688Z",
    fill: "#E0E0E0"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M181.217 201.691C181.19 201.756 181.145 201.814 181.084 201.86C181.024 201.906 180.951 201.939 180.872 201.954C180.793 201.969 180.71 201.968 180.633 201.948C180.555 201.929 180.484 201.894 180.426 201.845C180.082 201.583 179.782 201.282 179.534 200.95C179.236 200.401 179.381 199.13 179.469 198.525C179.672 197.168 179.897 194.058 181.203 193.256C181.554 193.141 181.938 193.117 182.305 193.188C182.452 193.202 182.587 193.261 182.685 193.355C182.782 193.448 182.836 193.569 182.835 193.694C182.826 196.418 182.279 199.121 181.217 201.691Z",
    fill: "url(#paint114_linear_1604_23319)"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M181.217 201.691C181.19 201.756 181.145 201.814 181.084 201.86C181.024 201.906 180.951 201.939 180.872 201.954C180.793 201.969 180.71 201.968 180.633 201.948C180.555 201.929 180.484 201.894 180.426 201.845C180.082 201.583 179.782 201.282 179.534 200.95C179.236 200.401 179.381 199.13 179.469 198.525C179.672 197.168 179.897 194.058 181.203 193.256C181.554 193.141 181.938 193.117 182.305 193.188C182.452 193.202 182.587 193.261 182.685 193.355C182.782 193.448 182.836 193.569 182.835 193.694C182.826 196.418 182.279 199.121 181.217 201.691Z",
    fill: "black"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M180.338 203.116H171.791V203.622H180.338V203.116Z",
    fill: "#263238"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M180.215 203.363L171.748 203.24C171.656 203.23 171.571 203.195 171.504 203.141C171.437 203.086 171.393 203.015 171.378 202.937C171.291 202.437 171.153 200.642 171.429 200.346C171.821 199.926 173.308 199.815 173.983 199.858C175.586 199.969 179.229 200.666 180.215 201.827C180.498 202.16 180.215 203.363 180.215 203.363Z",
    fill: "url(#paint115_linear_1604_23319)"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M180.215 203.363L171.748 203.24C171.656 203.23 171.571 203.195 171.504 203.141C171.437 203.086 171.393 203.015 171.378 202.937C171.291 202.437 171.153 200.642 171.429 200.346C171.821 199.926 173.308 199.815 173.983 199.858C175.586 199.969 179.229 200.666 180.215 201.827C180.498 202.16 180.215 203.363 180.215 203.363Z",
    fill: "black"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M171.748 203.24L180.216 203.363C180.31 202.957 180.347 202.543 180.324 202.129C179.098 201.129 175.579 200.531 173.983 200.438C173.257 200.395 171.727 200.5 171.32 200.895C171.317 200.911 171.317 200.928 171.32 200.944C171.289 201.61 171.321 202.276 171.415 202.937C171.427 203.011 171.466 203.079 171.526 203.133C171.586 203.187 171.663 203.224 171.748 203.24Z",
    fill: "black"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M172.133 205.381L171.698 203.653C171.691 203.625 171.692 203.597 171.7 203.57C171.708 203.543 171.723 203.517 171.744 203.495C171.764 203.474 171.79 203.456 171.82 203.444C171.85 203.432 171.882 203.425 171.915 203.425H178.271L177.691 205.381H172.133Z",
    fill: "#263238"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M172.133 205.381L171.698 203.653C171.691 203.625 171.692 203.597 171.7 203.57C171.708 203.543 171.723 203.517 171.744 203.495C171.764 203.474 171.79 203.456 171.82 203.444C171.85 203.432 171.882 203.425 171.915 203.425H178.271L177.691 205.381H172.133Z",
    fill: "#E0E0E0"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M181.216 201.691C182.281 199.113 182.828 196.401 182.834 193.669C182.834 193.572 182.802 193.476 182.74 193.394C182.678 193.312 182.59 193.247 182.485 193.207C182.321 193.203 182.158 193.237 182.014 193.305C180.664 194.132 180.425 197.353 180.214 198.76C180.127 199.377 179.975 200.704 180.287 201.271C180.45 201.513 180.652 201.733 180.889 201.925C180.961 201.91 181.028 201.881 181.084 201.84C181.141 201.8 181.186 201.748 181.216 201.691Z",
    fill: "black"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M182.828 191.176C182.829 191.064 182.803 190.953 182.752 190.849C182.701 190.746 182.626 190.652 182.531 190.574C182.435 190.496 182.323 190.436 182.199 190.396C182.076 190.356 181.944 190.338 181.812 190.343C181.547 190.348 181.295 190.442 181.11 190.603C180.926 190.765 180.823 190.982 180.825 191.207C180.825 191.51 180.789 192.114 180.789 192.441C180.789 192.768 181.224 192.972 181.74 192.966C182.255 192.96 182.639 192.707 182.661 192.411C182.683 192.114 182.806 191.479 182.828 191.176Z",
    fill: "url(#paint116_linear_1604_23319)"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M182.828 191.176C182.829 191.064 182.803 190.953 182.752 190.849C182.701 190.746 182.626 190.652 182.531 190.574C182.435 190.496 182.323 190.436 182.199 190.396C182.076 190.356 181.944 190.338 181.812 190.343C181.547 190.348 181.295 190.442 181.11 190.603C180.926 190.765 180.823 190.982 180.825 191.207C180.825 191.51 180.789 192.114 180.789 192.441C180.789 192.768 181.224 192.972 181.74 192.966C182.255 192.96 182.639 192.707 182.661 192.411C182.683 192.114 182.806 191.479 182.828 191.176Z",
    fill: "black"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M182.079 190.578C181.828 190.601 181.597 190.707 181.436 190.873C181.274 191.039 181.196 191.252 181.216 191.466C181.216 191.781 181.216 192.404 181.216 192.701C181.218 192.751 181.23 192.802 181.252 192.849C181.417 192.902 181.591 192.929 181.767 192.929C182.283 192.929 182.667 192.67 182.689 192.374C182.711 192.077 182.834 191.466 182.856 191.139C182.862 191.034 182.843 190.929 182.798 190.831C182.709 190.745 182.598 190.677 182.473 190.633C182.349 190.589 182.214 190.57 182.079 190.578Z",
    fill: "black"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M171.849 205.665C171.813 205.554 171.829 205.436 171.894 205.336C171.959 205.235 172.068 205.161 172.197 205.128L173.024 204.918C173.075 204.912 173.126 204.912 173.177 204.918H177.37L178.096 203.011C178.136 202.903 178.224 202.812 178.343 202.758L179.794 202.08C179.87 202.046 179.955 202.029 180.04 202.029C180.126 202.029 180.211 202.046 180.287 202.08L181.107 202.462L180.113 205.683L171.849 205.665Z",
    fill: "#263238"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M171.849 205.665C171.813 205.554 171.829 205.436 171.894 205.336C171.959 205.235 172.068 205.161 172.197 205.128L173.024 204.918C173.075 204.912 173.126 204.912 173.177 204.918H177.37L178.096 203.011C178.136 202.903 178.224 202.812 178.343 202.758L179.794 202.08C179.87 202.046 179.955 202.029 180.04 202.029C180.126 202.029 180.211 202.046 180.287 202.08L181.107 202.462L180.113 205.683L171.849 205.665Z",
    fill: "#E0E0E0"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M179.106 201.043C179.336 201.237 179.467 201.501 179.469 201.777V202.185L179.73 202.061L179.839 202.024V201.771C179.839 201.413 179.672 201.069 179.374 200.815L179.092 200.574C179.055 200.545 179.007 200.529 178.957 200.529C178.907 200.529 178.859 200.545 178.823 200.574C178.806 200.588 178.792 200.606 178.782 200.625C178.772 200.644 178.768 200.664 178.768 200.685C178.768 200.706 178.772 200.726 178.782 200.745C178.792 200.765 178.806 200.782 178.823 200.796L179.106 201.043Z",
    fill: "url(#paint117_linear_1604_23319)"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M178.509 200.213L178.412 200.296C178.273 200.414 178.273 200.605 178.412 200.724L178.663 200.937C178.802 201.055 179.027 201.055 179.166 200.937L179.263 200.854C179.402 200.736 179.402 200.545 179.263 200.427L179.012 200.213C178.873 200.095 178.648 200.095 178.509 200.213Z",
    fill: "#263238"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M166.692 195.175L164.588 195.619V194.959L166.561 194.743L166.692 195.175Z",
    fill: "url(#paint118_linear_1604_23319)"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M166.692 195.175L164.588 195.619V194.959L166.561 194.743L166.692 195.175Z",
    fill: "black"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M166.371 195.354L163.186 196.02V195.027L166.175 194.694L166.371 195.354Z",
    fill: "url(#paint119_linear_1604_23319)"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M166.894 196.39L166.052 193.552C166.043 193.526 166.041 193.498 166.045 193.471C166.049 193.444 166.06 193.418 166.076 193.394C166.092 193.371 166.114 193.35 166.14 193.334C166.165 193.317 166.195 193.306 166.226 193.299C166.29 193.286 166.358 193.295 166.415 193.323C166.472 193.352 166.514 193.399 166.531 193.453L167.372 196.286C167.388 196.34 167.377 196.396 167.343 196.444C167.309 196.491 167.254 196.525 167.191 196.539C167.16 196.546 167.128 196.548 167.096 196.544C167.064 196.541 167.033 196.532 167.005 196.518C166.978 196.504 166.953 196.486 166.934 196.464C166.915 196.442 166.901 196.417 166.894 196.39Z",
    fill: "url(#paint120_linear_1604_23319)"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.894 196.391L166.052 193.552C166.043 193.526 166.041 193.498 166.045 193.471C166.049 193.444 166.06 193.418 166.076 193.394C166.092 193.371 166.114 193.35 166.14 193.334C166.165 193.317 166.195 193.306 166.226 193.299C166.29 193.286 166.358 193.295 166.415 193.324C166.472 193.352 166.514 193.399 166.531 193.453L167.372 196.286C167.388 196.34 167.377 196.397 167.343 196.444C167.309 196.491 167.254 196.525 167.191 196.539C167.16 196.546 167.128 196.548 167.096 196.545C167.064 196.541 167.033 196.532 167.005 196.518C166.978 196.505 166.953 196.486 166.934 196.464C166.915 196.442 166.901 196.417 166.894 196.391Z",
    fill: "#E0E0E0"
  }))), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M166.531 193.453C166.52 193.421 166.501 193.392 166.475 193.367C166.448 193.343 166.415 193.323 166.379 193.311C166.327 193.33 166.285 193.364 166.26 193.407C166.234 193.45 166.228 193.499 166.241 193.546L167.054 196.273C167.06 196.299 167.073 196.323 167.091 196.345C167.109 196.366 167.132 196.384 167.158 196.398C167.185 196.412 167.214 196.421 167.245 196.425C167.275 196.429 167.307 196.428 167.337 196.421C167.351 196.379 167.351 196.334 167.337 196.292L166.531 193.453Z",
    fill: "#E0E0E0"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M161.531 197.149L163.519 202.049L161.531 199.957V197.149Z",
    fill: "url(#paint121_linear_1604_23319)"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M161.531 197.149L163.519 202.049L161.531 199.957V197.149Z",
    fill: "black"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M164.296 197.39L161.531 197.742V195.027H164.092C164.463 195.027 164.818 195.151 165.08 195.373C165.343 195.595 165.491 195.897 165.493 196.212C165.493 196.498 165.372 196.774 165.152 196.99C164.932 197.207 164.628 197.349 164.296 197.39Z",
    fill: "url(#paint122_linear_1604_23319)"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M164.296 197.39L161.531 197.742V195.027H164.092C164.463 195.027 164.818 195.151 165.08 195.373C165.343 195.595 165.491 195.897 165.493 196.212C165.493 196.498 165.372 196.774 165.152 196.99C164.932 197.207 164.628 197.349 164.296 197.39Z",
    fill: "#E0E0E0"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M161.756 197.452L161.531 197.483V195.379H161.575C161.9 195.379 162.212 195.488 162.442 195.684C162.672 195.88 162.801 196.145 162.801 196.421C162.802 196.671 162.697 196.913 162.505 197.103C162.313 197.292 162.047 197.416 161.756 197.452Z",
    fill: "black"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M164.862 198.371C165.101 198.056 165.958 197.902 166.807 197.859C169.353 197.748 171.791 197.76 173.467 198.476L173.612 197.97L178.909 198.772L179.025 200.716L175.18 201.382C171.856 200.852 167.452 200.321 166.473 199.784C166.56 200.629 165.747 202.252 165.102 203.69L163.65 202.092C164.049 200.734 164.594 198.643 164.862 198.371Z",
    fill: "url(#paint123_linear_1604_23319)"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M164.862 198.371C165.101 198.056 165.958 197.902 166.807 197.859C169.353 197.748 171.791 197.76 173.467 198.476L173.612 197.97L178.909 198.772L179.025 200.716L175.18 201.382C171.856 200.852 167.452 200.321 166.473 199.784C166.56 200.629 165.747 202.252 165.102 203.69L163.65 202.092C164.049 200.734 164.594 198.643 164.862 198.371Z",
    fill: "black"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M165.132 203.752L166.583 200.623C166.22 200.58 165.603 200.432 165.335 200.377L164.268 201.321L164.319 200.087C164.163 200.043 164.012 199.988 163.869 199.92L163.514 202.012L165.132 203.752Z",
    fill: "url(#paint124_linear_1604_23319)"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M175.623 192.281C174.222 193.034 172.967 194.015 171.218 194.2C169.848 194.078 168.501 193.815 167.206 193.416C167.129 193.385 167.067 193.332 167.031 193.266C166.996 193.2 166.988 193.126 167.011 193.056C167.033 192.986 167.084 192.925 167.154 192.884C167.225 192.842 167.31 192.823 167.395 192.83C168.519 192.984 170.442 193.071 171.218 193.102C172.27 192.849 173.852 191.763 174.81 191.25C174.969 191.173 175.156 191.15 175.334 191.185C175.512 191.22 175.668 191.311 175.771 191.439C175.874 191.568 175.915 191.725 175.888 191.879C175.86 192.032 175.766 192.172 175.623 192.269V192.281Z",
    fill: "#FCB373"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M167.279 192.818L166.104 192.478L166.503 193.749C166.503 193.749 167.605 193.891 167.649 193.404L167.279 192.818Z",
    fill: "#FCB373"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M165.094 192.954L165.478 193.99L166.501 193.749L166.102 192.478L165.094 192.954Z",
    fill: "#FCB373"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M169.775 192.978L169.608 194.083L167.627 193.589L167.881 192.855L169.775 192.978Z",
    fill: "url(#paint125_linear_1604_23319)"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M169.775 192.978L169.608 194.083L167.627 193.589L167.881 192.855L169.775 192.978Z",
    fill: "#E0E0E0"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M172.574 190.714C172.788 191.334 173.231 191.879 173.837 192.269L175.23 193.126C175.58 192.905 175.822 192.582 175.912 192.219C175.947 192.023 175.923 191.822 175.844 191.636C175.764 191.449 175.63 191.283 175.455 191.152L172.915 190.596C172.654 190.529 172.574 190.541 172.574 190.714Z",
    fill: "#263238"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M172.574 190.714C172.788 191.334 173.231 191.879 173.837 192.269L175.23 193.126C175.58 192.905 175.822 192.582 175.912 192.219C175.947 192.023 175.923 191.822 175.844 191.636C175.764 191.449 175.63 191.283 175.455 191.152L172.915 190.596C172.654 190.529 172.574 190.541 172.574 190.714Z",
    fill: "#E0E0E0"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M175.404 191.183C175.121 191.602 174.628 192.861 174.011 195.829C173.881 196.446 173.445 197.964 173.445 197.964L178.909 198.791L179.409 197.248L179.605 196.384L179.888 195.767L181.107 192.065C181.117 192.036 181.119 192.005 181.114 191.975C181.109 191.945 181.096 191.916 181.077 191.891C181.058 191.865 181.033 191.843 181.003 191.826C180.973 191.81 180.939 191.798 180.904 191.793L175.782 191.016C175.706 191.007 175.629 191.017 175.561 191.047C175.494 191.077 175.439 191.125 175.404 191.183Z",
    fill: "#263238"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M176.652 187.925C176.028 188.073 175.927 188.832 176.369 189.264C176.631 188.855 176.73 188.385 176.652 187.925Z",
    fill: "#263238"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M176.652 187.925C176.028 188.073 175.927 188.832 176.369 189.264C176.631 188.855 176.73 188.385 176.652 187.925Z",
    fill: "#E0E0E0"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M178.04 191.392C177.539 191.392 176.371 190.899 176.966 192.836C176.966 192.836 180.942 191.485 178.04 191.392Z",
    fill: "#FCB373"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M178.437 189.535C178.467 190.227 178.626 190.91 178.908 191.559C178.908 191.559 177.951 192.232 177.254 191.689C177.404 191.378 177.404 191.03 177.254 190.72C177.044 190.183 178.437 189.535 178.437 189.535Z",
    fill: "#FCB373"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M178.438 189.998H178.046L177.255 190.547C177.24 190.604 177.24 190.663 177.255 190.72C177.336 190.899 177.368 191.091 177.35 191.281C178.489 191.164 178.438 189.998 178.438 189.998Z",
    fill: "black"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M178.859 188.998C178.786 189.8 178.793 190.276 178.314 190.695C178.16 190.835 177.963 190.936 177.746 190.987C177.529 191.038 177.299 191.037 177.082 190.984C176.865 190.931 176.67 190.828 176.517 190.687C176.365 190.545 176.261 190.371 176.218 190.183C176.022 189.467 176.174 188.27 177.103 187.937C177.251 187.878 177.411 187.845 177.574 187.839C177.737 187.833 177.9 187.855 178.054 187.903C178.207 187.952 178.347 188.025 178.467 188.12C178.586 188.215 178.683 188.329 178.75 188.455C178.843 188.625 178.881 188.812 178.859 188.998Z",
    fill: "#FCB373"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M176.798 189.338C176.736 189.532 176.594 189.701 176.398 189.813C176.418 189.848 176.448 189.877 176.485 189.9C176.521 189.923 176.564 189.937 176.609 189.942L176.798 189.338Z",
    fill: "#EC873E"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M177.719 188.924C177.724 188.921 177.728 188.917 177.73 188.912C177.733 188.907 177.734 188.902 177.734 188.897C177.734 188.891 177.733 188.886 177.73 188.881C177.728 188.877 177.724 188.872 177.719 188.869C177.669 188.826 177.607 188.794 177.538 188.777C177.47 188.76 177.397 188.757 177.327 188.77C177.317 188.774 177.308 188.779 177.302 188.787C177.295 188.795 177.292 188.804 177.291 188.813C177.291 188.819 177.292 188.824 177.294 188.829C177.297 188.834 177.301 188.838 177.306 188.841C177.311 188.844 177.317 188.846 177.324 188.847C177.33 188.847 177.336 188.846 177.342 188.844C177.397 188.835 177.454 188.836 177.508 188.849C177.563 188.862 177.613 188.886 177.654 188.918L177.719 188.924Z",
    fill: "#263238"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M176.203 188.924C176.21 188.927 176.218 188.929 176.225 188.929C176.233 188.929 176.24 188.927 176.247 188.924C176.289 188.891 176.34 188.866 176.395 188.851C176.45 188.836 176.509 188.831 176.566 188.838C176.578 188.838 176.589 188.834 176.597 188.827C176.605 188.82 176.61 188.811 176.61 188.801C176.614 188.796 176.617 188.789 176.617 188.782C176.617 188.776 176.614 188.769 176.61 188.764C176.539 188.754 176.467 188.759 176.399 188.777C176.331 188.795 176.269 188.827 176.218 188.869C176.213 188.872 176.21 188.877 176.207 188.881C176.204 188.886 176.203 188.891 176.203 188.897C176.203 188.902 176.204 188.907 176.207 188.912C176.21 188.917 176.213 188.921 176.218 188.924H176.203Z",
    fill: "#263238"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M176.804 190.214H176.674C176.674 190.214 176.674 190.214 176.71 190.214C176.819 190.229 176.93 190.223 177.036 190.197C177.141 190.17 177.238 190.123 177.32 190.06H177.356V190.09C177.279 190.142 177.19 190.179 177.095 190.2C177 190.221 176.901 190.226 176.804 190.214Z",
    fill: "#263238"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M177.423 189.295C177.423 189.362 177.365 189.412 177.314 189.399C177.263 189.387 177.234 189.344 177.241 189.276C177.249 189.208 177.299 189.165 177.35 189.171C177.401 189.177 177.43 189.233 177.423 189.295Z",
    fill: "#263238"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M176.559 189.233C176.559 189.301 176.501 189.35 176.451 189.344C176.4 189.338 176.371 189.282 176.378 189.22C176.385 189.159 176.436 189.103 176.487 189.109C176.538 189.116 176.567 189.171 176.559 189.233Z",
    fill: "#263238"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M179.329 188.116C179.329 188.116 180.171 188.591 178.749 190.306C178.737 190.319 178.72 190.328 178.702 190.332C178.683 190.337 178.664 190.336 178.645 190.331C178.627 190.326 178.611 190.316 178.6 190.302C178.589 190.289 178.583 190.273 178.582 190.257L178.626 189.64C178.626 189.64 178.06 189.64 178.328 188.486L179.329 188.116Z",
    fill: "#263238"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M179.329 188.116C179.329 188.116 180.171 188.591 178.749 190.306C178.737 190.319 178.72 190.328 178.702 190.332C178.683 190.337 178.664 190.336 178.645 190.331C178.627 190.326 178.611 190.316 178.6 190.302C178.589 190.289 178.583 190.273 178.582 190.257L178.626 189.64C178.626 189.64 178.06 189.64 178.328 188.486L179.329 188.116Z",
    fill: "#E0E0E0"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M176.739 189.369L176.609 189.628C176.421 189.629 176.234 189.614 176.05 189.585L176.014 189.017C176.933 188.834 177.898 188.923 178.749 189.27L178.662 189.486C178.065 189.576 177.461 189.626 176.855 189.634L176.739 189.369Z",
    fill: "url(#paint126_linear_1604_23319)"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.523 189.609L177.08 188.918H177.203L177.639 189.597L177.523 189.609Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.564 188.931H176.913L177.363 189.64H177.022L176.564 188.931Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.31 189.615L176.027 189.177V189.017L176.419 189.634L176.31 189.615Z",
    fill: "#E0E0E0"
  }))), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M179.206 189.671C179.14 189.842 179.004 189.987 178.821 190.078C178.575 190.189 178.408 190.016 178.43 189.788C178.451 189.56 178.611 189.282 178.879 189.264C179.148 189.245 179.286 189.43 179.206 189.671Z",
    fill: "#FCB373"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M179.33 189.905C179.185 190.146 178.924 190.276 178.742 190.195C178.561 190.115 178.525 189.856 178.67 189.615C178.815 189.375 179.076 189.251 179.265 189.332C179.453 189.412 179.475 189.665 179.33 189.905Z",
    fill: "black"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M179.374 189.924C179.273 190.103 179.077 190.195 178.939 190.134C178.801 190.072 178.787 189.887 178.888 189.714C178.99 189.541 179.186 189.443 179.324 189.504C179.462 189.566 179.483 189.751 179.374 189.924Z",
    fill: "url(#paint127_linear_1604_23319)"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M179.163 189.492C179.163 189.492 179.947 188.079 178.895 187.641L178.931 187.61C179.143 187.666 179.326 187.784 179.446 187.943C179.664 188.209 179.852 188.56 179.315 189.547L179.163 189.492Z",
    fill: "url(#paint128_linear_1604_23319)"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M178.19 188.536C177.77 188.628 177.326 188.604 176.922 188.469C176.518 188.334 176.175 188.094 175.941 187.783C175.694 187.166 176.478 186.913 177.109 186.907C177.15 186.907 177.191 186.915 177.228 186.93C177.265 186.944 177.299 186.965 177.326 186.991C177.353 187.018 177.374 187.048 177.386 187.081C177.399 187.115 177.403 187.15 177.399 187.184C177.392 187.195 177.389 187.206 177.389 187.218C177.389 187.23 177.392 187.242 177.399 187.252C177.552 187.191 177.713 187.146 177.878 187.116C177.99 187.1 178.106 187.115 178.207 187.158C178.309 187.202 178.392 187.271 178.444 187.357C178.495 187.431 178.655 187.48 179.017 187.468C179.743 187.468 179.649 188.085 179.286 188.147C178.923 188.209 178.473 188.443 178.19 188.536Z",
    fill: "#263238"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M179.563 187.949L179.875 187.227C179.708 186.845 177.952 186.61 176.138 186.425L175.826 186.752L175.891 187.585L179.563 187.949Z",
    fill: "#263238"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M176.138 186.425C176.283 187.826 176.138 188.067 176.929 188.468C176.327 188.258 175.942 188.005 175.899 187.616L175.826 186.752L176.138 186.425Z",
    fill: "#E0E0E0"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M179.874 195.94C179.748 196.113 179.654 196.303 179.599 196.502C179.599 196.582 179.599 196.736 179.555 196.921C179.512 197.106 179.504 197.353 179.483 197.575C179.439 197.989 179.395 198.353 179.395 198.353L175.811 197.637V197.02L175.405 197.581L173.402 197.279L173.78 196.397L173.838 196.255L173.903 195.78L173.961 195.372L174.048 194.755V194.533C174.296 193.268 174.89 192.069 175.782 191.035C176.024 190.952 176.288 190.928 176.544 190.966C176.801 191.004 177.039 191.103 177.233 191.251C176.312 191.59 176.936 192.812 176.936 192.812C177.697 192.252 178.586 191.831 179.548 191.578C179.772 191.532 180.006 191.529 180.232 191.57C180.458 191.611 180.67 191.693 180.854 191.812C178.808 192.54 180.295 195.156 180.295 195.156C180.179 195.426 180.038 195.688 179.874 195.94Z",
    fill: "url(#paint129_linear_1604_23319)"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M175.1 195.508C175.1 195.508 174.534 195.434 173.932 195.379L174.019 194.761C174.421 194.79 174.821 194.839 175.216 194.91L175.1 195.508Z",
    fill: "#E0E0E0"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M174.969 195.928L174.722 196.545C174.722 196.545 174.272 196.483 173.75 196.427L173.808 196.286L173.873 195.81C174.241 195.833 174.607 195.872 174.969 195.928Z",
    fill: "#E0E0E0"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.928 192.812C176.862 192.984 176.79 193.157 176.732 193.33C176.674 193.503 176.608 193.675 176.558 193.848C176.456 194.2 176.34 194.552 176.238 194.897C176.137 195.243 176.035 195.601 175.948 195.952C175.905 196.131 175.868 196.31 175.832 196.483C175.803 196.663 175.788 196.844 175.789 197.026C175.752 196.663 175.774 196.298 175.854 195.94C175.919 195.582 176.021 195.224 176.122 194.873C176.224 194.521 176.347 194.175 176.471 193.83C176.594 193.481 176.747 193.141 176.928 192.812Z",
    fill: "black"
  }))), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M180.882 192.515L179.917 193.132C179.838 193.448 179.838 193.774 179.917 194.089C179.942 194.158 179.984 194.223 180.039 194.279C180.093 194.335 180.161 194.382 180.236 194.416C180.352 194.416 180.469 194.366 180.592 194.212L181.107 192.552L180.882 192.515Z",
    fill: "#FCB373"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M179.961 193.028C180.09 193.639 180.17 194.258 180.2 194.879L180.926 192.664L179.961 193.028Z",
    fill: "black"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M174.571 198.13L179.099 198.828V199.938C178.988 200.509 178.685 201.04 178.228 201.469C176.383 203.308 174.235 204.91 171.85 206.226C172.75 206.578 174.23 209.151 175.246 210.397L174.375 211.15L169.746 207.047C169.376 206.707 169.47 206.337 169.608 205.856C170.544 203.715 173.236 201.216 174.832 200.056L174.571 198.13Z",
    fill: "url(#paint130_linear_1604_23319)"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M174.571 198.13L179.099 198.828V199.938C178.988 200.509 178.685 201.04 178.228 201.469C176.383 203.308 174.235 204.91 171.85 206.226C172.75 206.578 174.23 209.151 175.246 210.397L174.375 211.15L169.746 207.047C169.376 206.707 169.47 206.337 169.608 205.856C170.544 203.715 173.236 201.216 174.832 200.056L174.571 198.13Z",
    fill: "black"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M177.653 212.878L177.16 212.162C176.086 210.107 172.77 206.787 172.77 206.787C172.458 206.948 171.776 207.405 171.522 207.509L172.16 208.478L171.029 207.756C170.948 207.773 170.874 207.807 170.814 207.856C170.754 207.905 170.711 207.966 170.688 208.034L175.875 212.526C175.651 212.948 175.238 213.276 174.729 213.439C174.562 213.507 174.787 213.89 175.2 213.766C175.89 213.569 175.716 213.55 176.303 213.39C176.891 213.229 177.167 213.174 177.566 213.069C177.588 213.063 177.609 213.053 177.626 213.04C177.643 213.027 177.656 213.01 177.665 212.991C177.673 212.973 177.676 212.953 177.674 212.933C177.672 212.914 177.665 212.895 177.653 212.878Z",
    fill: "url(#paint131_linear_1604_23319)"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M171.545 200.852C172.718 200.869 173.871 200.592 174.861 200.056L173.577 201.154L171.545 200.852Z",
    fill: "black"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M166.371 199.303L166.465 199.833C166.906 200.024 167.375 200.166 167.858 200.253L166.371 199.303Z",
    fill: "black"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M173.3 197.803C173.3 197.803 176.13 198.291 178.843 198.63L178.647 199.247C178.647 199.247 175.709 198.914 173.111 198.39L173.3 197.803Z",
    fill: "#263238"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M175.925 198.168L175.547 198.11C175.342 198.078 175.146 198.193 175.108 198.368L175.082 198.489C175.045 198.664 175.181 198.831 175.386 198.862L175.764 198.921C175.969 198.953 176.166 198.837 176.203 198.663L176.229 198.541C176.266 198.367 176.13 198.2 175.925 198.168Z",
    fill: "#263238"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M175.925 198.168L175.547 198.11C175.342 198.078 175.146 198.193 175.108 198.368L175.082 198.489C175.045 198.664 175.181 198.831 175.386 198.862L175.764 198.921C175.969 198.953 176.166 198.837 176.203 198.663L176.229 198.541C176.266 198.367 176.13 198.2 175.925 198.168Z",
    fill: "#E0E0E0"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M175.859 198.288L175.516 198.235C175.37 198.212 175.23 198.294 175.204 198.418L175.186 198.503C175.159 198.627 175.256 198.746 175.402 198.769L175.744 198.822C175.89 198.844 176.03 198.762 176.057 198.638L176.075 198.553C176.101 198.429 176.005 198.31 175.859 198.288Z",
    fill: "black"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M173.918 197.822L175.035 197.995C175.035 197.995 174.861 199.229 174.505 199.284C174.15 199.34 173.62 199.229 173.584 198.957C173.65 198.57 173.762 198.19 173.918 197.822Z",
    fill: "#263238"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M173.918 197.822L175.035 197.995C175.035 197.995 174.861 199.229 174.505 199.284C174.15 199.34 173.62 199.229 173.584 198.957C173.65 198.57 173.762 198.19 173.918 197.822Z",
    fill: "#E0E0E0"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M175.036 197.995H174.876C174.657 198.174 174.51 198.407 174.455 198.661C174.332 199.142 174.288 199.328 174.455 199.315H174.499C174.861 199.223 175.036 197.995 175.036 197.995Z",
    fill: "black"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M175.036 197.995C174.973 198.011 174.915 198.039 174.867 198.077C174.818 198.114 174.779 198.16 174.753 198.211C174.732 198.243 174.7 198.27 174.661 198.287C174.622 198.303 174.578 198.309 174.535 198.303L173.94 198.211C173.907 198.205 173.877 198.192 173.851 198.175C173.825 198.157 173.805 198.134 173.791 198.108C173.778 198.082 173.772 198.054 173.774 198.026C173.776 197.997 173.785 197.97 173.802 197.945C173.837 197.902 173.876 197.86 173.918 197.822L175.036 197.995Z",
    fill: "#263238"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M175.036 197.995C174.973 198.011 174.915 198.039 174.867 198.077C174.818 198.114 174.779 198.16 174.753 198.211C174.732 198.243 174.7 198.27 174.661 198.287C174.622 198.303 174.578 198.309 174.535 198.303L173.94 198.211C173.907 198.205 173.877 198.192 173.851 198.175C173.825 198.157 173.805 198.134 173.791 198.108C173.778 198.082 173.772 198.054 173.774 198.026C173.776 197.997 173.785 197.97 173.802 197.945C173.837 197.902 173.876 197.86 173.918 197.822L175.036 197.995Z",
    fill: "#E0E0E0"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M174.106 198.464L173.889 198.433L174.012 198.081L174.23 198.112L174.106 198.464Z",
    fill: "#263238"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M174.106 198.464L173.889 198.433L174.012 198.081L174.23 198.112L174.106 198.464Z",
    fill: "#E0E0E0"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M177.799 198.427L176.682 198.254C176.682 198.254 176.333 199.451 176.645 199.618C176.957 199.784 177.502 199.827 177.647 199.587C177.743 199.205 177.794 198.817 177.799 198.427Z",
    fill: "#263238"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M177.799 198.427L176.682 198.254C176.682 198.254 176.333 199.451 176.645 199.618C176.957 199.784 177.502 199.827 177.647 199.587C177.743 199.205 177.794 198.817 177.799 198.427Z",
    fill: "#E0E0E0"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M176.682 198.254H176.849C176.975 198.487 177.013 198.748 176.957 199.001C176.87 199.488 176.841 199.673 176.682 199.618H176.645C176.333 199.451 176.682 198.254 176.682 198.254Z",
    fill: "black"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M176.682 198.254C176.733 198.287 176.776 198.33 176.806 198.379C176.836 198.428 176.853 198.482 176.856 198.538C176.862 198.574 176.882 198.608 176.912 198.634C176.942 198.661 176.98 198.679 177.023 198.686L177.618 198.778C177.651 198.784 177.686 198.783 177.719 198.775C177.752 198.766 177.781 198.751 177.805 198.73C177.829 198.709 177.847 198.683 177.856 198.655C177.865 198.627 177.865 198.597 177.857 198.569C177.845 198.519 177.826 198.472 177.799 198.427L176.682 198.254Z",
    fill: "#263238"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M176.682 198.254C176.733 198.287 176.776 198.33 176.806 198.379C176.836 198.428 176.853 198.482 176.856 198.538C176.862 198.574 176.882 198.608 176.912 198.634C176.942 198.661 176.98 198.679 177.023 198.686L177.618 198.778C177.651 198.784 177.686 198.783 177.719 198.775C177.752 198.766 177.781 198.751 177.805 198.73C177.829 198.709 177.847 198.683 177.856 198.655C177.865 198.627 177.865 198.597 177.857 198.569C177.845 198.519 177.826 198.472 177.799 198.427L176.682 198.254Z",
    fill: "#E0E0E0"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M177.355 198.97L177.573 199.001L177.602 198.637L177.392 198.599L177.355 198.97Z",
    fill: "#263238"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M177.355 198.97L177.573 199.001L177.602 198.637L177.392 198.599L177.355 198.97Z",
    fill: "#E0E0E0"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M179.155 198.637L178.045 198.464C178.045 198.464 177.689 199.661 178.001 199.827C178.313 199.994 178.857 200.037 179.003 199.797C179.099 199.415 179.15 199.027 179.155 198.637Z",
    fill: "#263238"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M179.155 198.637L178.045 198.464C178.045 198.464 177.689 199.661 178.001 199.827C178.313 199.994 178.857 200.037 179.003 199.797C179.099 199.415 179.15 199.027 179.155 198.637Z",
    fill: "#E0E0E0"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M178.045 198.464H178.204C178.331 198.697 178.369 198.958 178.313 199.21C178.233 199.698 178.204 199.883 178.045 199.827H178.001C177.689 199.661 178.045 198.464 178.045 198.464Z",
    fill: "black"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M178.045 198.464C178.096 198.498 178.137 198.541 178.167 198.59C178.197 198.639 178.215 198.693 178.219 198.748C178.222 198.784 178.239 198.819 178.268 198.845C178.297 198.872 178.336 198.89 178.379 198.896L178.974 198.988C179.007 198.994 179.042 198.993 179.075 198.984C179.108 198.976 179.138 198.96 179.161 198.94C179.185 198.919 179.203 198.893 179.212 198.865C179.221 198.836 179.221 198.807 179.213 198.778C179.205 198.728 179.185 198.68 179.155 198.637L178.045 198.464Z",
    fill: "#263238"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M178.045 198.464C178.096 198.498 178.137 198.541 178.167 198.59C178.197 198.639 178.215 198.693 178.219 198.748C178.222 198.784 178.239 198.819 178.268 198.845C178.297 198.872 178.336 198.89 178.379 198.896L178.974 198.988C179.007 198.994 179.042 198.993 179.075 198.984C179.108 198.976 179.138 198.96 179.161 198.94C179.185 198.919 179.203 198.893 179.212 198.865C179.221 198.836 179.221 198.807 179.213 198.778C179.205 198.728 179.185 198.68 179.155 198.637L178.045 198.464Z",
    fill: "#E0E0E0"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M178.713 199.179L178.931 199.216L178.96 198.846L178.749 198.809L178.713 199.179Z",
    fill: "#263238"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M178.713 199.179L178.931 199.216L178.96 198.846L178.749 198.809L178.713 199.179Z",
    fill: "#E0E0E0"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M172.64 197.625L173.758 197.797C173.758 197.797 173.584 199.031 173.228 199.087C172.873 199.142 172.343 199.031 172.307 198.76C172.372 198.373 172.484 197.992 172.64 197.625Z",
    fill: "#263238"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M172.64 197.625L173.758 197.797C173.758 197.797 173.584 199.031 173.228 199.087C172.873 199.142 172.343 199.031 172.307 198.76C172.372 198.373 172.484 197.992 172.64 197.625Z",
    fill: "#E0E0E0"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M173.757 197.797H173.598C173.379 197.977 173.232 198.21 173.177 198.464C173.053 198.945 173.003 199.13 173.177 199.118H173.22C173.583 199.025 173.757 197.797 173.757 197.797Z",
    fill: "black"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M173.756 197.797C173.694 197.814 173.636 197.842 173.587 197.879C173.538 197.916 173.5 197.962 173.473 198.013C173.453 198.046 173.421 198.072 173.382 198.089C173.343 198.106 173.299 198.111 173.256 198.106L172.661 198.013C172.628 198.007 172.598 197.995 172.572 197.977C172.546 197.959 172.526 197.936 172.512 197.911C172.499 197.885 172.493 197.856 172.494 197.828C172.496 197.8 172.506 197.772 172.523 197.748C172.558 197.704 172.596 197.663 172.639 197.625L173.756 197.797Z",
    fill: "#263238"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M173.756 197.797C173.694 197.814 173.636 197.842 173.587 197.879C173.538 197.916 173.5 197.962 173.473 198.013C173.453 198.046 173.421 198.072 173.382 198.089C173.343 198.106 173.299 198.111 173.256 198.106L172.661 198.013C172.628 198.007 172.598 197.995 172.572 197.977C172.546 197.959 172.526 197.936 172.512 197.911C172.499 197.885 172.493 197.856 172.494 197.828C172.496 197.8 172.506 197.772 172.523 197.748C172.558 197.704 172.596 197.663 172.639 197.625L173.756 197.797Z",
    fill: "#E0E0E0"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M172.829 198.266L172.611 198.235L172.735 197.877L172.952 197.914L172.829 198.266Z",
    fill: "#263238"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M172.829 198.266L172.611 198.235L172.735 197.877L172.952 197.914L172.829 198.266Z",
    fill: "#E0E0E0"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M181.369 192.873C182.074 193.846 182.686 194.865 183.197 195.921C183.408 196.489 182.668 196.674 182.283 197.069C181.549 197.705 180.766 198.299 179.94 198.846C179.863 198.895 179.766 198.916 179.671 198.905C179.575 198.893 179.489 198.85 179.432 198.785C179.382 198.73 179.355 198.662 179.355 198.593C179.355 198.524 179.382 198.457 179.432 198.402C179.867 197.958 180.302 197.513 180.73 197.051C181.178 196.563 181.663 196.102 182.182 195.668L181.978 196.316C181.714 195.834 181.414 195.366 181.079 194.916C180.781 194.299 179.352 193.157 180.397 192.62C180.565 192.546 180.762 192.53 180.944 192.578C181.125 192.625 181.278 192.731 181.369 192.873Z",
    fill: "#FCB373"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M179.619 198.229L178.451 197.865L178.821 199.149C178.821 199.149 179.924 199.309 179.975 198.822L179.619 198.229Z",
    fill: "#FCB373"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M177.43 198.328L177.8 199.371L178.823 199.149L178.453 197.871L177.43 198.328Z",
    fill: "#FCB373"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M181.688 197.674L180.731 196.896L179.562 198.174L180.121 198.828L181.688 197.674Z",
    fill: "url(#paint132_linear_1604_23319)"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M181.688 197.674L180.731 196.896L179.562 198.174L180.121 198.828L181.688 197.674Z",
    fill: "#E0E0E0"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M183.56 192.349C183.107 192.866 182.472 193.247 181.746 193.435L180.092 193.83C179.85 193.522 179.751 193.147 179.816 192.781C179.868 192.587 179.973 192.407 180.123 192.256C180.273 192.105 180.464 191.986 180.68 191.911L183.285 192.133C183.539 192.145 183.633 192.188 183.56 192.349Z",
    fill: "#263238"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M183.56 192.349C183.107 192.866 182.472 193.247 181.746 193.435L180.092 193.83C179.85 193.522 179.751 193.147 179.816 192.781C179.868 192.587 179.973 192.407 180.123 192.256C180.273 192.105 180.464 191.986 180.68 191.911L183.285 192.133C183.539 192.145 183.633 192.188 183.56 192.349Z",
    fill: "#E0E0E0"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M162.191 188.61L158.926 187.4L150.053 176.479L153.39 164.829L179.438 161.207L180.149 161.991L178.161 169.475L180.86 179.903L182.006 181.563L181.636 182.637L162.191 188.61Z",
    fill: "#263238"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M154.515 166.008L153.39 164.829L150.053 176.479L158.926 187.4L162.191 188.61L162.155 187.425L159.485 186.425L151.533 176.534L154.515 166.008Z",
    fill: "black"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M180.149 161.991L154.515 166.008L153.391 164.829L179.438 161.207L180.149 161.991Z",
    fill: "black"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M162.156 187.425L162.193 188.61L181.638 182.637L182.008 181.563L162.156 187.425Z",
    fill: "black"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M159.486 186.425L180.861 179.903L182.008 181.563L162.156 187.425L159.486 186.425Z",
    fill: "#E0E0E0"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M151.533 176.534L178.161 169.475L180.86 179.903L159.485 186.425L151.533 176.534Z",
    fill: "#263238"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M154.515 166.008L151.533 176.534L178.161 169.475L180.149 161.991L154.515 166.008Z",
    fill: "#E0E0E0"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M153.812 179.36L178.902 172.301L180.876 179.909L159.465 186.425L153.812 179.36Z",
    fill: "#263238"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M153.812 179.36L178.902 172.301L180.876 179.909L159.465 186.425L153.812 179.36Z",
    fill: "#E0E0E0"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M153.812 179.36L154.727 180.502L178.387 173.751L178.902 172.301L153.812 179.36Z",
    fill: "#263238"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M180.012 180.162L178.387 173.751L178.902 172.301L180.875 179.909L180.012 180.162Z",
    fill: "#263238"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M153.812 179.36L154.727 180.502L178.387 173.751L178.902 172.301L153.812 179.36Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1604_23319",
    x1: 96.5352,
    y1: 159.177,
    x2: 125.483,
    y2: 158.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1604_23319",
    x1: 113.031,
    y1: 159.196,
    x2: 134.378,
    y2: 158.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1604_23319",
    x1: 52.0371,
    y1: 159.195,
    x2: 99.0543,
    y2: 154.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1604_23319",
    x1: 152.049,
    y1: 115.114,
    x2: 173.316,
    y2: 114.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1604_23319",
    x1: 154.5,
    y1: 115.188,
    x2: 170.335,
    y2: 114.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1604_23319",
    x1: 149.443,
    y1: 159.202,
    x2: 176.479,
    y2: 158.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1604_23319",
    x1: 152.049,
    y1: 141.024,
    x2: 173.292,
    y2: 139.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1604_23319",
    x1: 152.049,
    y1: 159.054,
    x2: 173.16,
    y2: 157.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1604_23319",
    x1: 175.012,
    y1: 159.202,
    x2: 201.083,
    y2: 158.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1604_23319",
    x1: 185.004,
    y1: 155.524,
    x2: 188.922,
    y2: 155.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1604_23319",
    x1: 179.025,
    y1: 155.524,
    x2: 182.944,
    y2: 155.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1604_23319",
    x1: 191.055,
    y1: 155.524,
    x2: 194.973,
    y2: 155.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1604_23319",
    x1: 180.896,
    y1: 146.867,
    x2: 184.815,
    y2: 146.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1604_23319",
    x1: 189.109,
    y1: 146.867,
    x2: 193.028,
    y2: 146.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1604_23319",
    x1: 180.896,
    y1: 128.547,
    x2: 184.815,
    y2: 128.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1604_23319",
    x1: 189.109,
    y1: 128.547,
    x2: 193.028,
    y2: 128.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1604_23319",
    x1: 180.896,
    y1: 110.227,
    x2: 184.815,
    y2: 109.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1604_23319",
    x1: 189.109,
    y1: 110.227,
    x2: 193.028,
    y2: 109.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1604_23319",
    x1: 185.004,
    y1: 101.57,
    x2: 188.922,
    y2: 101.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1604_23319",
    x1: 185.004,
    y1: 92.4815,
    x2: 188.922,
    y2: 92.1664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1604_23319",
    x1: 185.004,
    y1: 137.71,
    x2: 188.922,
    y2: 137.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1604_23319",
    x1: 179.025,
    y1: 137.71,
    x2: 182.944,
    y2: 137.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1604_23319",
    x1: 191.055,
    y1: 137.71,
    x2: 194.973,
    y2: 137.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1604_23319",
    x1: 185.004,
    y1: 119.39,
    x2: 188.922,
    y2: 119.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1604_23319",
    x1: 179.025,
    y1: 119.39,
    x2: 182.944,
    y2: 119.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1604_23319",
    x1: 191.055,
    y1: 119.39,
    x2: 194.973,
    y2: 119.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1604_23319",
    x1: 202.641,
    y1: 43.279,
    x2: 212.353,
    y2: 39.5354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1604_23319",
    x1: 178.451,
    y1: 60.2413,
    x2: 211.272,
    y2: 27.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1604_23319",
    x1: 178.451,
    y1: 48.5731,
    x2: 211.272,
    y2: 16.1648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1604_23319",
    x1: 173.068,
    y1: 52.9973,
    x2: 187.511,
    y2: 22.9913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1604_23319",
    x1: 173.068,
    y1: 49.3568,
    x2: 173.884,
    y2: 41.4858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1604_23319",
    x1: 173.068,
    y1: 53.781,
    x2: 173.884,
    y2: 45.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1604_23319",
    x1: 206.029,
    y1: 52.5715,
    x2: 209.608,
    y2: 52.1117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1604_23319",
    x1: 237.605,
    y1: 52.5715,
    x2: 241.184,
    y2: 52.1117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1604_23319",
    x1: 174.055,
    y1: 52.5715,
    x2: 177.634,
    y2: 52.1117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1604_23319",
    x1: 190.047,
    y1: 52.5715,
    x2: 193.626,
    y2: 52.1117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1604_23319",
    x1: 221.818,
    y1: 52.5715,
    x2: 225.397,
    y2: 52.1117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1604_23319",
    x1: 213.924,
    y1: 52.5715,
    x2: 217.503,
    y2: 52.1117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1604_23319",
    x1: 229.713,
    y1: 52.5715,
    x2: 233.292,
    y2: 52.1117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1604_23319",
    x1: 198.041,
    y1: 52.5715,
    x2: 201.62,
    y2: 52.1117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1604_23319",
    x1: 182.051,
    y1: 52.5715,
    x2: 185.63,
    y2: 52.1117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1604_23319",
    x1: 171.428,
    y1: 52.5654,
    x2: 173.239,
    y2: 52.4487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1604_23319",
    x1: 242.373,
    y1: 52.5654,
    x2: 244.184,
    y2: 52.4487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1604_23319",
    x1: 203.178,
    y1: 159.202,
    x2: 213.141,
    y2: 159.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1604_23319",
    x1: 194.109,
    y1: 63.6783,
    x2: 214.586,
    y2: 49.6456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1604_23319",
    x1: 139.234,
    y1: 78.1169,
    x2: 142.855,
    y2: 78.0426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1604_23319",
    x1: 134.664,
    y1: 155.592,
    x2: 148.516,
    y2: 155.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1604_23319",
    x1: 139.279,
    y1: 98.1212,
    x2: 142.9,
    y2: 98.0469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1604_23319",
    x1: 140.02,
    y1: 39.6014,
    x2: 142.072,
    y2: 39.5837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1604_23319",
    x1: 128.859,
    y1: 62.8575,
    x2: 155.194,
    y2: 59.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1604_23319",
    x1: 128.736,
    y1: 53.9661,
    x2: 142.635,
    y2: 40.5206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1604_23319",
    x1: 128.736,
    y1: 51.2264,
    x2: 129.286,
    y2: 47.4219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_1604_23319",
    x1: 147.955,
    y1: 53.9661,
    x2: 148.502,
    y2: 53.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_1604_23319",
    x1: 147.955,
    y1: 51.7077,
    x2: 148.496,
    y2: 51.6471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_1604_23319",
    x1: 128.736,
    y1: 54.3486,
    x2: 129.285,
    y2: 50.5442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_1604_23319",
    x1: 135.869,
    y1: 99.1763,
    x2: 146.875,
    y2: 97.7623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_1604_23319",
    x1: 137.791,
    y1: 80.727,
    x2: 144.511,
    y2: 79.5395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_1604_23319",
    x1: 136.949,
    y1: 42.8532,
    x2: 145.553,
    y2: 41.4872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_1604_23319",
    x1: 133.082,
    y1: 159.214,
    x2: 147.286,
    y2: 152.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_1604_23319",
    x1: 224.213,
    y1: 123.043,
    x2: 231.523,
    y2: 118.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_1604_23319",
    x1: 244.172,
    y1: 130.232,
    x2: 258.9,
    y2: 129.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_1604_23319",
    x1: 244.172,
    y1: 130.423,
    x2: 249.186,
    y2: 123.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_1604_23319",
    x1: 244.172,
    y1: 127.936,
    x2: 249.185,
    y2: 120.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_1604_23319",
    x1: 244.172,
    y1: 125.37,
    x2: 249.185,
    y2: 118.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_1604_23319",
    x1: 244.172,
    y1: 122.901,
    x2: 249.185,
    y2: 115.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_1604_23319",
    x1: 244.172,
    y1: 120.341,
    x2: 249.185,
    y2: 113.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_1604_23319",
    x1: 244.172,
    y1: 117.774,
    x2: 249.185,
    y2: 110.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_1604_23319",
    x1: 244.172,
    y1: 115.287,
    x2: 249.185,
    y2: 108.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_1604_23319",
    x1: 244.172,
    y1: 112.727,
    x2: 249.185,
    y2: 105.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_1604_23319",
    x1: 244.172,
    y1: 110.258,
    x2: 249.185,
    y2: 103.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_1604_23319",
    x1: 244.172,
    y1: 107.691,
    x2: 249.185,
    y2: 100.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_1604_23319",
    x1: 240.77,
    y1: 159.072,
    x2: 263.347,
    y2: 157.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_1604_23319",
    x1: 240.777,
    y1: 159.072,
    x2: 246.431,
    y2: 150.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_1604_23319",
    x1: 240.777,
    y1: 156.209,
    x2: 246.372,
    y2: 147.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_1604_23319",
    x1: 240.77,
    y1: 153.253,
    x2: 246.302,
    y2: 144.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_1604_23319",
    x1: 240.777,
    y1: 150.409,
    x2: 246.252,
    y2: 141.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_1604_23319",
    x1: 240.77,
    y1: 147.46,
    x2: 246.22,
    y2: 138.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_1604_23319",
    x1: 240.777,
    y1: 144.504,
    x2: 246.165,
    y2: 135.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_1604_23319",
    x1: 240.777,
    y1: 141.641,
    x2: 246.061,
    y2: 132.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_1604_23319",
    x1: 240.77,
    y1: 138.685,
    x2: 245.986,
    y2: 129.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_1604_23319",
    x1: 240.777,
    y1: 135.841,
    x2: 245.937,
    y2: 126.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_1604_23319",
    x1: 240.77,
    y1: 132.891,
    x2: 245.904,
    y2: 123.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_1604_23319",
    x1: 216.479,
    y1: 159.14,
    x2: 235.236,
    y2: 157.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_1604_23319",
    x1: 216.479,
    y1: 159.14,
    x2: 221.514,
    y2: 150.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_1604_23319",
    x1: 216.479,
    y1: 154.932,
    x2: 220.418,
    y2: 147.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_1604_23319",
    x1: 216.479,
    y1: 152.655,
    x2: 220.418,
    y2: 144.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_1604_23319",
    x1: 216.479,
    y1: 150.304,
    x2: 220.418,
    y2: 142.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_1604_23319",
    x1: 216.479,
    y1: 148.039,
    x2: 220.418,
    y2: 140.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_1604_23319",
    x1: 216.479,
    y1: 145.689,
    x2: 220.418,
    y2: 137.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_1604_23319",
    x1: 216.479,
    y1: 141.474,
    x2: 218.051,
    y2: 136.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_1604_23319",
    x1: 216.479,
    y1: 141.271,
    x2: 235.236,
    y2: 139.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_1604_23319",
    x1: 216.479,
    y1: 141.277,
    x2: 221.514,
    y2: 132.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_1604_23319",
    x1: 216.479,
    y1: 137.062,
    x2: 220.418,
    y2: 129.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_1604_23319",
    x1: 216.479,
    y1: 134.786,
    x2: 220.418,
    y2: 127.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_1604_23319",
    x1: 216.479,
    y1: 132.435,
    x2: 220.418,
    y2: 124.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_1604_23319",
    x1: 216.479,
    y1: 130.176,
    x2: 220.418,
    y2: 122.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_1604_23319",
    x1: 216.479,
    y1: 127.819,
    x2: 220.418,
    y2: 120.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_1604_23319",
    x1: 216.479,
    y1: 123.605,
    x2: 218.051,
    y2: 118.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_1604_23319",
    x1: 228.166,
    y1: 86.9467,
    x2: 228.963,
    y2: 86.9431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_1604_23319",
    x1: 224.213,
    y1: 123.043,
    x2: 233.783,
    y2: 122.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_1604_23319",
    x1: 224.213,
    y1: 120.137,
    x2: 231.523,
    y2: 116.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_1604_23319",
    x1: 224.213,
    y1: 117.231,
    x2: 231.523,
    y2: 113.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_1604_23319",
    x1: 224.213,
    y1: 114.405,
    x2: 231.523,
    y2: 110.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_1604_23319",
    x1: 224.213,
    y1: 111.573,
    x2: 231.523,
    y2: 107.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_1604_23319",
    x1: 224.213,
    y1: 108.747,
    x2: 231.523,
    y2: 104.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_1604_23319",
    x1: 224.213,
    y1: 105.84,
    x2: 231.523,
    y2: 101.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_1604_23319",
    x1: 224.213,
    y1: 102.934,
    x2: 231.523,
    y2: 98.8195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_1604_23319",
    x1: 224.213,
    y1: 96.048,
    x2: 227.552,
    y2: 91.4662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_1604_23319",
    x1: 15.4551,
    y1: 227.242,
    x2: 65.8711,
    y2: 113.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_1604_23319",
    x1: 26.8477,
    y1: 194.712,
    x2: 46.0522,
    y2: 123.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_1604_23319",
    x1: 124.639,
    y1: 179.039,
    x2: 128.684,
    y2: 178.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_1604_23319",
    x1: 52.9961,
    y1: 171.999,
    x2: 55.6995,
    y2: 171.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_1604_23319",
    x1: 129.912,
    y1: 204.751,
    x2: 136.276,
    y2: 204.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_1604_23319",
    x1: 244.391,
    y1: 193.682,
    x2: 248.639,
    y2: 193.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_1604_23319",
    x1: 179.355,
    y1: 201.964,
    x2: 183.208,
    y2: 201.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_1604_23319",
    x1: 171.266,
    y1: 203.363,
    x2: 180.59,
    y2: 200.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_1604_23319",
    x1: 180.789,
    y1: 192.966,
    x2: 183.035,
    y2: 192.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_1604_23319",
    x1: 178.768,
    y1: 202.185,
    x2: 179.95,
    y2: 202.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_1604_23319",
    x1: 164.588,
    y1: 195.619,
    x2: 166.772,
    y2: 195.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_1604_23319",
    x1: 163.186,
    y1: 196.02,
    x2: 166.491,
    y2: 195.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_1604_23319",
    x1: 166.043,
    y1: 196.546,
    x2: 167.522,
    y2: 196.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_1604_23319",
    x1: 161.531,
    y1: 202.049,
    x2: 163.732,
    y2: 201.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_1604_23319",
    x1: 161.531,
    y1: 197.742,
    x2: 165.817,
    y2: 197.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_1604_23319",
    x1: 163.65,
    y1: 203.69,
    x2: 179.419,
    y2: 199.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_1604_23319",
    x1: 163.514,
    y1: 203.752,
    x2: 166.892,
    y2: 203.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_1604_23319",
    x1: 167.627,
    y1: 194.083,
    x2: 169.925,
    y2: 193.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_1604_23319",
    x1: 176.014,
    y1: 189.634,
    x2: 178.591,
    y2: 188.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_1604_23319",
    x1: 178.822,
    y1: 190.153,
    x2: 179.504,
    y2: 190.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_1604_23319",
    x1: 178.895,
    y1: 189.547,
    x2: 179.747,
    y2: 189.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_1604_23319",
    x1: 173.402,
    y1: 198.353,
    x2: 181.569,
    y2: 197.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_1604_23319",
    x1: 169.486,
    y1: 211.15,
    x2: 180.08,
    y2: 210.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_1604_23319",
    x1: 170.688,
    y1: 213.791,
    x2: 178.347,
    y2: 212.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_1604_23319",
    x1: 179.563,
    y1: 198.828,
    x2: 181.887,
    y2: 198.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartCity);
export default __webpack_public_path__ + "static/media/Smart-City.5a9ac909e7348ce0b19203753b1487ea.svg";
export { ForwardRef as ReactComponent };